webpackJsonp([1],{

/***/ "/Suc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef52442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("/Suc")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883f7ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("T53c")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3078df0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("eBnN")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Revue Olympique - Numero 113",
  "shortTitle": "",
  "description": "",
  "width": 800,
  "height": 900,
  "currentLanguage": "FR",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/113"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/113"
  }],
  "basePath": "/113",
  "companyLogo": "1-logo.png",
  "publishURL": "http://revueolympique.touchlines.com/113/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img id=\"1-title\" class=\"halfScale\" style=\"top:53px;left:4px\" src=\"/113/static/_content/1-title.png\">\n      <img id=\"1-sub-1\" class=\"halfScale\" style=\"top:17px;left:17px\" src=\"/113/static/_content/1-sub-1.png\">\n      <img id=\"1-sub-2\" class=\"halfScale\" style=\"top:16px;left:351px\" src=\"/113/static/_content/1-sub-2.png\">\n      <img id=\"1-sub-3\" class=\"halfScale\" style=\"top:188px;left:275px\" src=\"/113/static/_content/1-sub-3.png\">\n      \n      <img id=\"1-logo\" class=\"halfScale\" style=\"top:812px;left:664px\" src=\"/113/static/_content/1-logo.png\">\n      <div class=\"addContentLink\" style=\"top:868px;left:664px;height:16px;width:120px;\">\n        <a href=\"http://www.olympic.org/fr\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(idOf(\"1-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"1-sub-1\"), 0.6, {opacity:0, x:80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"1-sub-2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(idOf(\"1-sub-3\"), 0.6, {opacity:0, y:-80},{opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"1-logo\"), 0.6, {opacity:0, y:80},{opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "PUBLICATION OFFICIELLE DU MOUVEMENT OLYMPIQUE OCTOBRE-NOVEMBRE-DÉCEMBRE 2019 NUMÉRO 113  C’EST ICI QUE TOUT COMMENCE DE NOUVELLES ÉPREUVES PASSIONNANTES COMME LE SKI ALPINISME SÉDUIRONT LE PUBLIC DES JEUX OLYMPIQUES DE LA JEUNESSE D’HIVER DE LAUSANNE 2020  WWW.OLYMPIC.ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 4-title\" style=\"top:133px;left:66px\" src=\"/113/static/_content/4-title.png\">\n        <img class=\"halfScale 4-title\" style=\"top:181px;left:67px\" src=\"/113/static/_content/4-sub.png\">\n        <img id=\"4-img\" class=\"halfScale\" style=\"top:239px;left:66px\" src=\"/113/static/_content/4-img-1.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:364px;left:67px\" src=\"/113/static/_content/4-img-2.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:487px;left:67px\" src=\"/113/static/_content/4-img-3.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:610px;left:67px\" src=\"/113/static/_content/4-img-4.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:733px;left:67px\" src=\"/113/static/_content/4-img-5.jpg\">\n\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top:240px;left:67px;width:100px;height:100px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(26)\" style=\"top:365px;left:67px;width:101px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(42)\" style=\"top:488px;left:67px;width:101px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(62)\" style=\"top:611px;left:67px;width:101px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top:734px;left:67px;width:101px;height:98px\"></div>\n        \n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top:237px;left:196px;width:126px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8)\" style=\"top:272px;left:196px;width:114px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(12)\" style=\"top:306px;left:196px;width:110px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(24)\" style=\"top:341px;left:196px;width:190px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(26)\" style=\"top:388px;left:196px;width:213px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(42)\" style=\"top:458px;left:196px;width:222px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(56)\" style=\"top:504px;left:196px;width:186px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(62)\" style=\"top:551px;left:196px;width:247px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(68)\" style=\"top:598px;left:196px;width:180px;height:26px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top:668px;left:196px;width:97px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(78)\" style=\"top:714px;left:196px;width:178px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(81)\" style=\"top:761px;left:196px;width:72px;height:14px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(82)\" style=\"top:809px;left:196px;width:90px;height:13px\"></div>\n\n        <div class=\"addContentLink\" style=\"top:704px;left:628px;width:56px;height:9px\">\n        <a href=\"http://www.olympic.org/fr\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:712px;left:608px;width:88px;height:9px\">\n        <a href=\"mailto:olympicreview@olympic.org\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n          .fromTo(idOf(\"4-img\"), 0.6, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.4\")\n          .staggerFromTo(cOf(\"4-imgs\"), 0.6, {opacity:0, y:-120},{opacity:1, y:0, ease: Power2.easeOut}, 0.2, \"-=0.2\", addContentLinks)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "REVUE OLYMPIQUE  SOMMAIRE PUBLICATION OFFICIELLE DU MOUVEMENT OLYMPIQUE OCTOBRE-NOVEMBRE-DÉCEMBRE 2019  7 AVANT-PROPOS Par le président du CIO, Thomas Bach.  8 INSTANTANÉS Spectaculaires images sportives du trimestre précédent.  Dernières nouvelles et autres événements du Mouvement olympique.  24 AU-DELÀ DES ANNEAUX Le syndic de Lausanne, Grégoire Junod, explique pourquoi les Jeux Olympiques de la Jeunesse (JOJ) auront un impact positif sur la région hôte.  26 DOSSIER: LAUSANNE 2020 La capitale olympique s’apprête à accueillir les 3es Jeux Olympiques de la Jeunesse d’hiver. À cette occasion la Revue Olympique se penche sur le festival exceptionnel, culturel et sportif qui va être offert aux athlètes et aux fans.  42 JEUNES REPORTERS DU CIO Nous nous sommes intéressés au succès du programme des jeunes reporters du CIO de retour pour une sixième édition à Lausanne.  56 À TRAVERS L’OBJECTIF Coup d’œil en images sur les participants des JOJ d’hiver qui ont hissé depuis leur carrière à de nouveaux sommets.  62 TOKYO 2020 EN POINT DE MIRE Le golfeur prodige norvégien Viktor Hovland vise un retour sur la scène olympique à Tokyo après avoir concouru aux JOJ de Nanjing 2014.  68 DANS LES COULISSES D’OLYMPIC CHANNEL  Le nouveau documentaire d’Olympic Channel, Running in North Korea, a suivi deux olympiennes d’hiver dans l’inconnu du marathon de Pyongyang.  74 MES JEUX La biathlète norvégienne Tora Berger revient sur sa brillante carrière olympique.  78 ÉTUDES OLYMPIQUES Sous les projecteurs du Centre d’Études Olympiques du CIO: l’Olympic World Library.  81 DÉCÈS Olympiens et personnalités du Mouvement olympique récemment décédés.  82 EN BREF Faits et chiffres à propos des innovations de Lausanne 2020.  4 REVUE OLYMPIQUE  COMMISSION EXÉCUTIVE Président Thomas Bach Vice-Présidents Juan Antonio Samaranch, Uğur Erdener, Anita L. DeFrantz, Zaiqing Yu Membres Sergey Bubka, Ser Miang Ng, Willi Kaltschmitt Luján, Robin E. Mitchell, Nicole Hoevertsz, Denis Oswald, Nenad Lalovic, Kirsty Coventry, Ivo Ferriani, S.A.R. le Prince Feisal Al Hussein REVUE OLYMPIQUE Directeur de la communication institutionnelle et des affaires publiques Christian Klaue Rédactrice en chef Katharine Mann Édition française Blandine Potemsky Édition espagnole Dolores Blázquez Agence de production Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Gruffudd Owen, Conor Ketley Design John Paul Yetton, Vanesha Ramdoyal, Liz Rankin, Ana Burmester Image Jason Dutch Secrétariat de rédaction Sylvie Venet-Tupy Traduction Denis Echard, Relecture Libero Language Lab ISSN: 0251-3498 Imprimé au Royaume-Uni IMAGES Couverture: ISMF/ Maurizio Torri. Intérieur: CIO; CIO/ Greg Martin; CIO/ Philippe Woods; CIO/ Ubald Rutar; CIO/ Richard Juilliart; CIO/ Raitis Purins; CIO/ Polina Golovina; CIO/ Ian Jones; CIO/ Jed Leicester; CIO/ John Buckle; Getty Images; Olympic Information Service; Lausanne 2020; Lausanne Tourisme; Ville de Lausanne; Olympic Channel; Storm Studios; Christian Petersen Clausen/ Kyoro Tours; IBSF/ Ģirts Kehris; ISMF; CNO brésilien; CTOC; J Lindberg; MIT; BTV. CONTACTS Écrivez-nous à: Revue Olympique, Département de la communication institutionnelle et des affaires publiques du CIO, Château de Vidy, 1007 Lausanne, Suisse Site internet: www.olympic.org e-mail: olympicreview@olympic.org tél. +41 (0)21 621 6111 fax +41 (0)21 621 6356 La Revue Olympique est imprimée sur du papier certifié PEFC fabriqué à partir de bois de forêts gérées dans le souci du développement durable. La Revue Olympique est publiée par le Comité International Olympique. Les articles publiés dans la Revue Olympique ne reflètent pas nécessairement l’opinion du CIO. Toute reproduction sans l’accord du département de la communication institutionnelle et des affaires publiques du CIO est interdite.  Toutes les informations sont correctes au moment de l’impression.  12 ACTUALITÉS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Ci-contre: Lausanne, la capitale olympique, est prête à accueillir les Jeux Olympiques de la Jeunesse d’hiver."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:760px;left:315px;height:21px;width:172px;\">\n          <a href=\"https://www.airbnb.fr/d/olympics\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "AVANT-PROPOS  AVANT-PROPOS PAR THOMAS BACH PRÉSIDENT DU COMITÉ INTERNATIONAL OLYMPIQUE  L Ci-dessus, à droite: le président Bach rencontre des écoliers lors du voyage de la flamme pour Lausanne 2020.  ’enthousiasme monte à Lausanne et les régions avoisinantes pour les 3es Jeux Olympiques de la Jeunesse (JOJ) d’hiver qui auront lieu dans la capitale olympique en janvier. Les JOJ de Lausanne 2020 sont les Jeux de nombreuses premières. En effet, ce sera la première fois que les JOJ d’hiver se dérouleront en Suisse. Ce sera aussi la première édition des JOJ d’hiver à afficher une complète égalité des sexes, avec le même nombre d’athlètes masculins et féminins. Quelques nouveaux sports particulièrement attractifs auprès des jeunes, comme le hockey sur glace 3 x 3, figureront également pour la première fois au programme. Tandis que Lausanne s’apprête à accueillir des jeunes du monde entier venus faire admirer leur talent sur l’aire de  compétition, il faut souligner que les JOJ vont bien au-delà du sport. Ils portent également beaucoup sur l’unité et la participation et sont autant d’occasions éducatives et d’apprentissage pour les jeunes. La ville de Lausanne sera au centre de ces JOJ, mais le programme verra des épreuves sportives se dérouler dans trois régions suisses: les cantons de Vaud, du Valais et des Grisons, ainsi qu’en France. Ce sera la première fois que les épreuves olympiques de la jeunesse auront lieu de part et d’autre de frontières nationales. Les JOJ d’hiver de Lausanne 2020 sont aussi particulièrement participatifs dans la manière dont ils ont été préparés et organisés. La jeunesse locale y a pris part de bien des façons. L’implication des écoles  et universités locales de la ville et la région a été très forte, notamment à l’Université de Lausanne. En effet, le village olympique de la jeunesse qui hébergera les jeunes athlètes est situé dans le Vortex, bâtiment construit sur le campus de l’université. Illustration du statut de véritable catalyseur d’unité de la communauté locale des JOJ, quelque 800 volontaires de l’université, d’organisations locales ainsi que du CIO ont formé une équipe pour fabriquer le mobilier des chambres qui accueilleront les athlètes durant la manifestation. Après les JOJ, le Vortex deviendra une résidence universitaire. Le Vortex ne sera pas le seul héritage tangible de cette manifestation. D’importants efforts ont été réalisés pour que les sites et équipements existants soient utilisés pour les compétitions et que toute nouvelle construction corresponde à la vision à long terme de la ville. C’est ainsi que le seul site nouvellement rénové, la Vaudoise aréna de Lausanne, a été envisagé en tenant compte de cette vision à long terme. Par ailleurs, les épreuves de bobsleigh, de skeleton, de luge et de patinage de vitesse se dérouleront sur des sites existants à Saint-Moritz, où ont eu lieu les Jeux d’hiver de 1928 et de nouveau en 1948, autre héritage significatif et signe de continuité avec un illustre passé. Au cours de ces JOJ, les jeunes de la région auront la possibilité d’être inspirés par les performances de leurs pairs, mais aussi de s’essayer eux-mêmes à plusieurs sports. Par ailleurs, quelques journalistes en herbe qui couvriront les épreuves feront partie du programme des jeunes reporters du CIO, destiné à les aider à renforcer leur talent et leurs compétences. Alors que nous approchons de 2020, les JOJ de Lausanne que nous accueillerons au début de la nouvelle année seront véritablement les Jeux par les jeunes, pour les jeunes. Ce sera un moment spécial pour la capitale olympique, résidence du CIO depuis plus de 100 ans. ■  REVUE OLYMPIQUE 7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 7-title\" style=\"top:484px;left:149px\" src=\"/113/static/_content/7-title.png\">\n        <img class=\"halfScale 7-title\" style=\"top:559px;left:150px\" src=\"/113/static/_content/7-sub.png\">\n       \n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:801px;left:581px;height:33px;width:123px\">\n          <img class=\"halfScale\" src=\"/113/static/_content/7-sig.png\">\n        </div>\n\n        <img id=\"7-ctr\" style=\"top:485px;left:50px;cursor:pointer;\" onclick=\"pg7show();\" src=\"/113/static/_content/clicktoread.png\">\n        \n        <div id=\"pg7read\" class=\"d-hidden\">\n          <img id=\"pg7close\" onclick=\"pg7readclose();\" src=\"/113/static/_content/x-button.png\">\n          <p>\n            L\u2019enthousiasme monte \xE0 Lausanne et les r\xE9gions avoisinantes pour les 3es Jeux Olympiques de la Jeunesse (JOJ) d\u2019hiver qui auront lieu dans la capitale olympique en janvier.\n          </p>\n          <p>\n            Les JOJ de Lausanne 2020 sont les Jeux de nombreuses premi\xE8res. En effet, ce sera la premi\xE8re fois que les JOJ d\u2019hiver se d\xE9rouleront en Suisse. Ce sera aussi la premi\xE8re \xE9dition des JOJ d\u2019hiver \xE0 afficher une compl\xE8te \xE9galit\xE9 des sexes, avec le m\xEAme nombre d\u2019athl\xE8tes masculins et f\xE9minins. Quelques nouveaux sports particuli\xE8rement attractifs aupr\xE8s des jeunes, comme le hockey sur glace 3 x 3, figureront \xE9galement pour la premi\xE8re fois au programme.\n          </p>\n          <p>\n            Tandis que Lausanne s\u2019appr\xEAte \xE0 accueillir des jeunes du monde entier venus faire admirer leur talent sur l\u2019aire de  comp\xE9tition, il faut souligner que les JOJ vont bien au-del\xE0 du sport. Ils portent \xE9galement beaucoup sur l\u2019unit\xE9 et la participation et sont autant d\u2019occasions \xE9ducatives et d\u2019apprentissage pour les jeunes.\n          </p>\n          <p>\n            La ville de Lausanne sera au centre de ces JOJ, mais le programme verra des \xE9preuves sportives se d\xE9rouler dans trois r\xE9gions suisses: les cantons de Vaud, du Valais et des Grisons, ainsi qu\u2019en France. Ce sera la premi\xE8re fois que les \xE9preuves olympiques de la jeunesse auront lieu de part et d\u2019autre de fronti\xE8res nationales. \n          </p>\n          <p>\n            Les JOJ d\u2019hiver de Lausanne 2020 sont aussi particuli\xE8rement participatifs dans la mani\xE8re dont ils ont \xE9t\xE9 pr\xE9par\xE9s et organis\xE9s. La jeunesse locale y a pris part de bien des fa\xE7ons. L\u2019implication des \xE9coles  et universit\xE9s locales de la ville et la r\xE9gion a \xE9t\xE9 tr\xE8s forte, notamment \xE0 l\u2019Universit\xE9 de Lausanne. En effet, le village olympique de la jeunesse qui h\xE9bergera les jeunes athl\xE8tes est situ\xE9 dans le Vortex, b\xE2timent construit sur le campus de l\u2019universit\xE9. Illustration du statut de v\xE9ritable catalyseur d\u2019unit\xE9 de la communaut\xE9 locale des JOJ, quelque 800 volontaires de l\u2019universit\xE9, d\u2019organisations locales ainsi que du CIO ont form\xE9 une \xE9quipe pour fabriquer le mobilier des chambres qui accueilleront les athl\xE8tes durant la manifestation. Apr\xE8s les JOJ, le Vortex deviendra une r\xE9sidence universitaire.\n          </p>\n          <p>\n            Le Vortex ne sera pas le seul h\xE9ritage tangible de cette manifestation. D\u2019importants efforts ont \xE9t\xE9 r\xE9alis\xE9s pour que les sites et \xE9quipements existants soient utilis\xE9s pour les comp\xE9titions et que toute nouvelle construction corresponde \xE0 la vision \xE0 long terme de la ville. C\u2019est ainsi que le seul site nouvellement r\xE9nov\xE9, la Vaudoise ar\xE9na de Lausanne, a \xE9t\xE9 envisag\xE9 en tenant compte de cette vision \xE0 long terme. Par ailleurs, les \xE9preuves de bobsleigh, de skeleton, de luge et de patinage de vitesse se d\xE9rouleront sur des sites existants \xE0 Saint-Moritz, o\xF9 ont eu lieu les Jeux d\u2019hiver de 1928 et de nouveau en 1948, autre h\xE9ritage significatif et signe de continuit\xE9 avec un illustre pass\xE9. Au cours de ces JOJ, les jeunes de la r\xE9gion auront la possibilit\xE9 d\u2019\xEAtre inspir\xE9s par les performances de leurs pairs, mais aussi de s\u2019essayer eux-m\xEAmes \xE0 plusieurs sports. \n          </p>\n          <p>Par ailleurs, quelques journalistes en herbe qui couvriront les \xE9preuves feront partie du programme des jeunes reporters du CIO, destin\xE9 \xE0 les aider \xE0 renforcer leur talent et leurs comp\xE9tences. Alors que nous approchons de 2020, les JOJ de Lausanne que nous accueillerons au d\xE9but de la nouvelle ann\xE9e seront v\xE9ritablement les Jeux par les jeunes, pour les jeunes. Ce sera un moment sp\xE9cial pour la capitale olympique, r\xE9sidence du CIO depuis plus de 100 ans.</p>\n        </div>  \n      ",
    "script": "\n      function onPageEnter() {\n        pg7Anim = new TimelineMax();\n        pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n        .fromTo(idOf(\"7-sig\"), 0.6, {width:\"0px\"}, {width:\"123px\", ease: Power2.easeOut}, \"-=0.4\")\n        .fromTo(idOf(\"7-ctr\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n      }\n\n      function pg7show() {\n        var k =  document.getElementById(\"pg7read\")\n        k.className = \"readOverlay visible\"\n      }\n\n      function pg7readclose() {\n        var k =  document.getElementById(\"pg7read\")\n        k.className = \"d-hidden\"\n      }\n\n      function onPageLeave() {\n        pg7readclose();\n        pg7Anim.stop();\n      }\n      ",
    "searchText": "AVANT-PROPOS  AVANT-PROPOS PAR THOMAS BACH PRÉSIDENT DU COMITÉ INTERNATIONAL OLYMPIQUE  L Ci-dessus, à droite: le président Bach rencontre des écoliers lors du voyage de la flamme pour Lausanne 2020.  ’enthousiasme monte à Lausanne et les régions avoisinantes pour les 3es Jeux Olympiques de la Jeunesse (JOJ) d’hiver qui auront lieu dans la capitale olympique en janvier. Les JOJ de Lausanne 2020 sont les Jeux de nombreuses premières. En effet, ce sera la première fois que les JOJ d’hiver se dérouleront en Suisse. Ce sera aussi la première édition des JOJ d’hiver à afficher une complète égalité des sexes, avec le même nombre d’athlètes masculins et féminins. Quelques nouveaux sports particulièrement attractifs auprès des jeunes, comme le hockey sur glace 3 x 3, figureront également pour la première fois au programme. Tandis que Lausanne s’apprête à accueillir des jeunes du monde entier venus faire admirer leur talent sur l’aire de  compétition, il faut souligner que les JOJ vont bien au-delà du sport. Ils portent également beaucoup sur l’unité et la participation et sont autant d’occasions éducatives et d’apprentissage pour les jeunes. La ville de Lausanne sera au centre de ces JOJ, mais le programme verra des épreuves sportives se dérouler dans trois régions suisses: les cantons de Vaud, du Valais et des Grisons, ainsi qu’en France. Ce sera la première fois que les épreuves olympiques de la jeunesse auront lieu de part et d’autre de frontières nationales. Les JOJ d’hiver de Lausanne 2020 sont aussi particulièrement participatifs dans la manière dont ils ont été préparés et organisés. La jeunesse locale y a pris part de bien des façons. L’implication des écoles  et universités locales de la ville et la région a été très forte, notamment à l’Université de Lausanne. En effet, le village olympique de la jeunesse qui hébergera les jeunes athlètes est situé dans le Vortex, bâtiment construit sur le campus de l’université. Illustration du statut de véritable catalyseur d’unité de la communauté locale des JOJ, quelque 800 volontaires de l’université, d’organisations locales ainsi que du CIO ont formé une équipe pour fabriquer le mobilier des chambres qui accueilleront les athlètes durant la manifestation. Après les JOJ, le Vortex deviendra une résidence universitaire. Le Vortex ne sera pas le seul héritage tangible de cette manifestation. D’importants efforts ont été réalisés pour que les sites et équipements existants soient utilisés pour les compétitions et que toute nouvelle construction corresponde à la vision à long terme de la ville. C’est ainsi que le seul site nouvellement rénové, la Vaudoise aréna de Lausanne, a été envisagé en tenant compte de cette vision à long terme. Par ailleurs, les épreuves de bobsleigh, de skeleton, de luge et de patinage de vitesse se dérouleront sur des sites existants à Saint-Moritz, où ont eu lieu les Jeux d’hiver de 1928 et de nouveau en 1948, autre héritage significatif et signe de continuité avec un illustre passé. Au cours de ces JOJ, les jeunes de la région auront la possibilité d’être inspirés par les performances de leurs pairs, mais aussi de s’essayer eux-mêmes à plusieurs sports. Par ailleurs, quelques journalistes en herbe qui couvriront les épreuves feront partie du programme des jeunes reporters du CIO, destiné à les aider à renforcer leur talent et leurs compétences. Alors que nous approchons de 2020, les JOJ de Lausanne que nous accueillerons au début de la nouvelle année seront véritablement les Jeux par les jeunes, pour les jeunes. Ce sera un moment spécial pour la capitale olympique, résidence du CIO depuis plus de 100 ans. ■  REVUE OLYMPIQUE 7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INSTANTANÉ  06/10/2019 ATHLÉTISME  L’Allemand Johannes Vetter s’élance lors de la finale du lancer du javelot des Championnats du monde d’athlétisme à Doha (Qatar). Tenant du titre, il a terminé à la troisième place alors que le Grenadien Anderson Peters a enlevé le premier titre mondial de sa prometteuse carrière avec un jet de 86,89 m. Photo: Getty Images"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INSTANTANÉ  10/10/2019 GYMNASTIQUE  La sensation américaine Simone Biles a de nouveau écrit une page d’histoire aux Championnats du monde de gymnastique de la FIG à Stuttgart (Allemagne). La multiple championne olympique s’est classée première dans cinq des six épreuves. Elle a ainsi porté sa moisson de médailles mondiales à 25 unités, soit deux de plus que le record de 23 médailles établi par Vitaly Scherbo en 1996. Photo: Getty Images"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "YOU PUSH YOURSELF TO NEW HEIGHTS. WE PUSH FOR NEW WAYS TO PAY.  Kanoa Igarashi Team Visa  Visa. The exclusive payment technology partner of Tokyo 2020 and Worldwide Sponsor of the Olympic Games for over 30 years."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:188px;left:68px;width:629px;height:53px\">\n          <img class=\"halfScale\" id=\"12-title-1\" src=\"/113/static/_content/12-title.png\">\n        </div>\n\n        <a href=\"https://iocnewsroom.com/video/ioc-and-airbnb-announce-major-global-olympic-partnership/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:183px;left:63px;width:629px;height:48px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(idOf(\"12-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n    \n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LE CIO ET AIRBNB ANNONCENT UN PARTENARIAT OLYMPIQUE MONDIAL MAJEUR Le 18 novembre, le Comité International Olympique (CIO) et Airbnb ont annoncé un accord important pour soutenir le Mouvement olympique jusqu’en 2028. Ce partenariat, qui couvrira cinq éditions des Jeux sur neuf ans, a pour but de créer une nouvelle norme en matière d’hébergement, grâce à laquelle tout le monde sera gagnant: les villes hôtes, les spectateurs et les fans, mais aussi les athlètes. Ces efforts conjoints, qui s’inscriront dans le cadre de l’Agenda olympique 2020, seront également conformes aux Objectifs de développement durable de l’ONU, à savoir offrir des possibilités de voyage qui soient économiquement émancipatrices, socialement inclusives et environnementalement viables. L’accord comprend des dispositions relatives à l’hébergement qui permettront de réduire les coûts pour les organisateurs des Jeux Olympiques et les autres parties prenantes, de réduire au minimum les besoins en matière de construction de nouveaux logements pour la période des Jeux et de générer un revenu direct pour les résidents et hôtes locaux. En collaboration avec le Comité International Paralympique, Airbnb fera également la promotion d’un hébergement qui favorise l’accessibilité des personnes non valides ou ayant d’autres besoins en matière d’accessibilité. En outre, le CIO et Airbnb vont lancer les Expériences olympiques Airbnb, afin d’offrir aux athlètes des possibilités de revenus directs, alors que tout au long de ce partenariat, le CIO mettra à la disposition des athlètes des logements Airbnb d’une valeur totale d’au moins 28 millions d’USD dans le cadre de leurs déplacements pour les compétitions et les entraînements.  12 REVUE OLYMPIQUE  «Ce partenariat novateur renforce notre stratégie qui est de s’assurer que l’organisation efficace des Jeux est durable et laisse un héritage à la communauté hôte, a dit Thomas Bach, le président du CIO. Avec le soutien d’Airbnb, nous offrirons également aux athlètes du monde entier de nouvelles opportunités de générer leurs propres sources de revenus par le biais de la promotion de l’activité physique et des valeurs olympiques.» Ci-dessus: le président Bach et le co-fondateur d’Airbnb Joe Gebbia, lors de l’annonce à Londres."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:188px;left:229px;width:504px;height:51px\">\n          <img class=\"halfScale\" id=\"13-title-1\" src=\"/113/static/_content/13-title.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:188px;left:49px;width:144px;height:51px\">\n          <img class=\"halfScale\" id=\"13-title-2\" src=\"/113/static/_content/13-sub-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:310px;left:587px;width:144px;height:51px\">\n          <img class=\"halfScale\" id=\"13-title-3\" src=\"/113/static/_content/13-sub-2.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(idOf(\"13-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"13-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"13-title-3\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg13Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "APPEL AU RESPECT DE LA NEUTRALITÉ POLITIQUE  Le 17 octobre à Doha (Qatar), dans un discours à l’assemblée générale de l’Association des Comités Nationaux Olympiques (ACNO), le président du CIO, Thomas Bach, a appelé l’audience à «respecter la neutralité politique dans tout ce qui est entrepris. Il n’appartient pas au sport de prendre parti sur le plan politique, a-t-il dit. Notre mission est de rassembler le monde entier dans une compétition pacifique. Pour y parvenir, nous devons nous en tenir aux principes de solidarité, de neutralité politique, de respect et d’unité dans tout ce que nous faisons et tout ce que nous disons.» Devant un parterre composé des représentants de plus de 200 CNO, le président du CIO a souligné l’importance de la solidarité pour l’unité du Mouvement olympique. «Aucun CNO ne saurait donner la priorité à ses intérêts; aucun sport ne saurait donner la priorité à ses intérêts; aucun individu ne saurait donner la priorité à ses intérêts. Nous devons tous faire passer notre mission en premier. Nous devons garder à l’esprit les valeurs de solidarité, de neutralité politique, de respect et d’unité.» Ci-dessous: le président Bach s’adresse aux représentants de plus de 200 CNO à Doha.  LUTTE ACTIVE CONTRE LE DOPAGE  LE PRÉSIDENT BACH VISITE LE QATAR ET L’ARABIE SAOUDITE  Le président du CIO, Thomas Bach, a encouragé toutes les parties prenantes de la lutte contre le dopage à «unir leurs forces pour envoyer un message fort de détermination, de coopération et de crédibilité aux athlètes du monde entier et au grand public». S’adressant aux 1 500 délégués présents à la cinquième Conférence mondiale de l’Agence Mondiale Antidopage (AMA) sur le dopage dans le sport à Katowice (Pologne), Thomas Bach a insisté sur la nécessité d’avoir une tolérance zéro pour les membres de l’entourage des athlètes impliqués dans des cas de dopage et annoncé un engagement de dix millions d’USD de la part du CIO afin de soutenir un plan d’action en quatre points visant à renforcer la lutte contre le dopage. Le plan prévoit la conservation des échantillons prélevés avant les  Jeux Olympiques pendant dix ans, un nouveau test antidopage via le séquençage génétique, plus d’argent pour la poursuite de la recherche scientifique et le renforcement des pouvoirs d’enquête de l’AMA (plus de détails en page 16). Outre ce nouveau plan, le président du CIO, Thomas Bach, a insisté sur la nécessité d’une meilleure coopération avec les états, lorsqu’il est question d’identifier et de sanctionner les membres de l’entourage des athlètes impliqués dans des cas de dopage. Les athlètes Goldie Sayers (photo ci-dessus) et Anita Włodarczyk ont également fait part à la Conférence mondiale de l’AMA de leur satisfaction vis-à-vis du processus de réattribution des médailles olympiques du CIO.  En septembre, le président du CIO, Thomas Bach, a visité Doha (Qatar) et Djeddah (Arabie saoudite), démontrant le pouvoir du sport de construire des ponts. À Doha, le président Bach a assisté aux Championnats du monde d’athlétisme et a été accueilli par le président du CNO du Qatar, Cheik Joaan bin Hamad bin Khalifa Al-Thani. Les deux dirigeants ont parlé du nombre croissant d’épreuves sportives dans le pays. À Djeddah, le président Bach a été accueilli par le président du CNO saoudien, le Prince Abdulaziz bin Turki al Saud. Il a visité plusieurs nouvelles installations sportives et le conseil exécutif du CNO lui a expliqué le plan de modernisation prévu pour le sport saoudien, prévoyant un meilleur accès aux femmes athlètes. «Je suis très heureux de voir que le sport, qu’il soit de masse ou d’élite, se développe en Arabie saoudite, a déclaré le président Bach. L’enthousiasme des jeunes athlètes m’a vraiment touché, et voir en particulier les nombreuses jeunes filles faire du sport est vraiment un signe très encourageant», a-t-il ajouté. Ci-dessus: le président Bach participe à une séance d’escrime avec des jeunes à Djeddah.  REVUE OLYMPIQUE 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:404px;left:246px;width:316px;height:64px\">\n          <img class=\"halfScale\" id=\"14-title-1\" src=\"/113/static/_content/14-title.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:307px;left:66px;width:148px;height:43px\">\n          <img class=\"halfScale\" id=\"14-title-2\" src=\"/113/static/_content/14-sub-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:215px;left:616px;width:82px;height:22px\">\n          <img class=\"halfScale\" id=\"14-title-3\" src=\"/113/static/_content/14-sub-2.png\">\n        </div>\n\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/SH7ZmruCuUI')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:30px; height:30px;left:178px;top:262px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(idOf(\"14-title-1\"), 0.6, {y:75}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"14-title-2\"), 0.6, {y:51}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"14-title-3\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "EN BREF  LE PRÉSIDENT BACH EN VISITE DANS LES PAYS AFRICAINS Le 12 novembre, le président du CIO, Thomas Bach, était au Sénégal afin d’y constater l’avancement des préparatifs en vue des Jeux Olympiques de la Jeunesse (JOJ) de Dakar 2022, dans le cadre plus large d’une tournée de cinq jours sur le continent africain. Le président Bach s’est rendu sur un certain nombre de sites de Dakar 2020 et a rencontré le président du Sénégal, Macky Sall, qui a évoqué «la fierté de son pays, de son peuple et de son président» d’organiser les JOJ. Le voyage africain du président du CIO avait débuté la veille au Cap-Vert, où il avait été accueilli par plus de 3 000 jeunes participant à une course populaire dans le cadre de l’opération “Sport for Life”, menée en collaboration avec l’UNICEF. La tournée a continué au Nigeria où le président Bach a assisté à l’inauguration du nouveau siège de l’Association des Comités Nationaux Olympiques d’Afrique (ACNOA) à Abuja, la capitale nigériane. Enfin, elle s’est finie au Cameroun où Thomas Bach a rencontré le Premier ministre du pays, Joseph Ngute, des centaines d’écoliers et d’olympiens au siège du CNO du Cameroun. Ci-dessus: le président Bach a rencontré la jeunesse locale dans quatre pays africains.  14 REVUE OLYMPIQUE  LE CIO SE FÉLICITE DE NOUVELLES MESURES POUR L’INTÉGRITÉ DU SPORT Le 28 octobre, la troisième édition du Forum international pour l’intégrité du sport (IFSI) a rassemblé les principaux dirigeants d’organisations sportives et internationales telles que le Conseil de l’Europe, l’Office des Nations Unies contre la drogue et le crime (ONUDC), INTERPOL et EUROPOL, ainsi que les opérateurs de paris sportifs et les autorités de régulation nationales. Tous les participants ont réaffirmé leur détermination à protéger les athlètes intègres et le principe de l’équité dans la compétition. «Ce rassemblement reflète la nature même de l’IFSI qui est la coopération et le partenariat, a rappelé le président du CIO, Thomas Bach. Nous sommes une communauté qui partage un objectif commun, celui de protéger les compétitions de toute manipulation et de la corruption qui y est associée.» Lors du Forum, le lancement d’une nouvelle publication a été annoncé: “IOC-UNODC Reporting Mechanisms in Sport: A Practical  Guide for Development and Implementation” (Guide pratique pour la création et la mise en œuvre de mécanismes de signalement dans le sport). Ce guide, co-produit par le CIO et l’ONUDC rassemble à l’attention des organisations sportives les bonnes pratiques relatives à la réception et au traitement des signalements d’actes répréhensibles, relevant notamment de la manipulation de compétition, du harcèlement, du dopage et de la corruption. Au cours du Forum, le CIO et EUROPOL ont signé un protocole d’accord qui établira un cadre de coopération mutuelle entre les deux organisations. Ce cadre facilitera le partage de compétences techniques, la diffusion d’informations et la participation à des efforts communs en lien avec la manipulation des compétitions et le crime organisé qui y est associé. Ci-dessus: le président Bach s’adresse aux leaders des organisations sportives internationales.  Intel annonce des innovations pour Tokyo 2020 Le partenaire olympique mondial Intel a révélé comment sa technologie de pointe allait être source d’innovations aux Jeux. En partenariat avec le CIO, Tokyo 2020 et d’autres partenaires des Jeux, Intel s’engage à faire de Tokyo 2020 les Jeux Olympiques les plus novateurs de l’histoire grâce aux technologies 5G et aux plateformes d’infrastructure, ouvrant la voie à la connectivité Gigabit, à de nouvelles solutions de mobilité, à des expériences plus immersives pour les téléspectateurs, à des applications de pointe pour les villes intelligentes, ainsi qu’à des services de diffusion. Le CIO attribue les droits de diffusion au Japon Le CIO a attribué à Japan Consortium les droits de diffusion au Japon pour les Jeux durant la période allant de 2026 à 2032. Le diffuseur a acquis les droits de diffusion exclusifs à la télévision et sur les plateformes numériques, en s’engageant à proposer la couverture la plus complète qui soit. «Grâce à l’expertise de diffusion sportive de Japan Consortium et la passion que le groupe voue aux valeurs olympiques, nous pouvons garantir une couverture remarquable des Jeux pour les nombreuses années à venir», a dit Thomas Bach."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:190px;left:66px;width:304px;height:46px\">\n          <img class=\"halfScale\" id=\"15-title-1\" src=\"/113/static/_content/15-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:430px;left:408px;width:324px;height:63px\">\n          <img class=\"halfScale\" id=\"15-title-2\" src=\"/113/static/_content/15-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:663px;left:50px;width:650px;height:25px\">\n          <img class=\"halfScale\" id=\"15-title-3\" src=\"/113/static/_content/15-title-3.png\">\n        </div>\n\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/-CgvRsX38As')\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:65px;top:142px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n          <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n          <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n        </svg>\n      </a>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(idOf(\"15-title-1\"), 0.6, {y:74}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"15-title-2\"), 0.6, {y:65}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"15-title-3\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg15Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOUS UNIS CONTRE LE CHANGEMENT CLIMATIQUE Le septembre, les signataires de l’accord-cadre des Nations Unies “Le sport au service de l’action climatique” se sont réunis au Musée Olympique (ci-dessous) pour définir les prochaines étapes de la lutte de la communauté sportive contre le changement climatique. Leur réunion – qui est la première rencontre officielle des participants à l’accord-cadre – a été organisée par le CIO en prélude à la tenue du Sommet des Nations Unies sur le climat à New York (USA). «À l’heure où la lutte mondiale contre le changement  climatique, une problématique cruciale, prend une ampleur sans précédent, la communauté sportive prouve une fois de plus que son pouvoir s’étend bien au-delà de l’aire de compétition», a déclaré S.A.S. le Prince Albert II de Monaco, membre du CIO et président de sa commission durabilité et héritage. Et d’ajouter: «L’accord-cadre des Nations Unies “Le sport au service de l’action climatique” est une formidable occasion d’utiliser ce pouvoir pour aider le monde à faire face à la menace du changement climatique sur notre planète.»  MARIO ET SONIC DE RETOUR DANS LE JEU VIDÉO DE TOKYO 2020 Dans le cadre de son programme mondial de licences, le CIO a lancé Mario & Sonic aux Jeux Olympiques de Tokyo 2020, sixième volet de la saga de jeux vidéo Mario & Sonic aux Jeux, combinaison sportive des franchises Super Mario de Nintendo et Sonic le Hérisson de SEGA. En plus de récréer diverses disciplines olympiques – y compris les nouveaux sports que sont le surf, le skateboard, le karaté et  l’escalade – avec de superbes images 3D, le jeu, qui est sorti en novembre, propose un mode rétro en 2D qui ramène Mario et Sonic aux Jeux Olympiques de Tokyo 1964 pour une expérience de jeu nostalgique. Ci-dessus: les personnages emblématiques de Mario et Sonic emmèneront les joueurs à l’aventure pour Tokyo 2020.  LES FI RÉCOMPENSÉES POUR LEURS ACTIONS EN FAVEUR DU CLIMAT Le 30 octobre, dans le cadre de la Session sur la durabilité du Forum des FI 2019, le CIO et le partenaire olympique mondial Dow ont récompensé dix Fédérations Internationales (FI) pour les mesures concrètes qu’elles ont prises afin de réduire leurs émissions de gaz à effet de serre. Des crédits carbone seront offerts à ces FI afin de compenser leurs  inévitables émissions en 2019. Cette reconnaissance s’inscrit dans le droit fil d’une initiative conjointe CIO-Dow, qui a pour but d’intensifier les efforts que le Mouvement olympique déploie pour aider à accélérer les actions en faveur du climat. «Nous sommes ravis de voir autant de FI prendre des mesures concrètes pour réduire leurs  émissions de gaz à effet de serre», a déclaré S.A.S. le Prince Albert II de Monaco, membre du CIO et président de la commission durabilité et héritage du CIO. «Cette initiative conjointe CIO-Dow permettra d’accélérer ces efforts, d’accroître leur impact et d’encourager d’autres organisations sportives à passer elles aussi à l’action.»  Les mesures de réduction des émissions de carbone prises par les Fédérations Internationales récompensées comprennent des initiatives liées à leurs opérations et à leurs événements qui diminuent les déchets et évaluent et réduisent l’empreinte des matériaux, des aliments et des équipements tout au long de leur cycle de vie.  REVUE OLYMPIQUE 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:185px;left:263px;width:484px;height:44px\">\n          <img class=\"halfScale\" id=\"16-title-1\" src=\"/113/static/_content/16-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:186px;left:66px;width:154px;height:43px\">\n          <img class=\"halfScale\" id=\"16-title-2\" src=\"/113/static/_content/16-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:674px;left:66px;width:622px;height:26px\">\n          <img class=\"halfScale\" id=\"16-title-3\" src=\"/113/static/_content/16-title-3.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(idOf(\"16-title-1\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"16-title-2\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"16-title-3\"), 0.6, {y:32}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg16Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LE PRÉSIDENT DU CIO REÇOIT TROIS DISTINCTIONS  ÉVALUATION DE L’ÉTAT D’AVANCEMENT DU GROUPE DE TRAVAIL SUR LA BOXE  Le 9 octobre, le président du CIO, Thomas Bach, s’est vu décerner la plus haute distinction grecque, la Grand-Croix de l’Ordre du Phénix, lors d’une cérémonie qui s’est déroulée à Athènes. S’exprimant à cette occasion, Prokopis Pavlopoulos (photo), le président grec, a notamment salué la «contribution exemplaire du président du CIO aux valeurs et principes de l’esprit et de l’idéal olympiques». Puis, le 6 novembre, le président Bach a été nommé docteur honoris causa de l’Université de Gdansk, lors d’une cérémonie dans la capitale polonaise. Enfin, une semaine plus tard à Dakar, le président du CIO a été fait commandeur de «l’Ordre national du Lion», par le président du Sénégal, Macky Sall.  Les 2 et 3 octobre, au cours de sa réunion à la Maison Olympique, la commission exécutive du CIO a été informée de l’état d’avancement des préparatifs de la boxe pour Tokyo 2020 après la suspension de l’Association Internationale de Boxe (AIBA). Le groupe de travail sur la boxe olympique a largement insisté sur le dialogue avec les CNO, les fédérations nationales et les athlètes en utilisant chaque occasion comme les Jeux conti-  nentaux, dans le cadre d’une vaste stratégie de sensibilisation, menée par la commission des athlètes du CIO. En parallèle, un site Web multilingue sur le sujet a été lancé sur Athlete365, la plateforme du CIO pour les athlètes. Au cours des deux jours de réunion, la commission exécutive du CIO a présenté une initiative visant à collaborer avec l’Agence de contrôles internationale (ACI) et l’Agence Mondiale Antidopage  (AMA) afin de mettre en place un plan de stockage à long terme des échantillons qui viendrait compléter le programme de contrôle mené avant les Jeux de Tokyo 2020.  LA PARITÉ AU SEIN DES COMMISSIONS DES FUTURS HÔTES DU CIO La 134e Session du CIO ayant accepté en juin dernier l’évolution des futures élections de la ville hôte des Jeux Olympiques, la commission exécutive du CIO a approuvé, le 3 octobre, la manière dont cette nouvelle approche sera mise en œuvre. La Session du CIO avait décidé d’adopter une approche plus ciblée, plus rationnelle qui comprend la  16 REVUE OLYMPIQUE  création de deux commissions distinctes (été et hiver) qui feront des suggestions à la commission exécutive du CIO, laquelle à son tour présentera ses recommandations à la Session du CIO. Après consultation de la commission exécutive, les deux commissions ont été nommées par le président du CIO. Elles affichent toutes  deux un parfait équilibre entre les sexes: cinq femmes et cinq hommes pour la commission d’été; et quatre femmes et quatre hommes pour la commission d’hiver. La Norvégienne Kristin Kloster Aasen et le Roumain Octavian Morariu, tous deux membres du CIO, ont été chargés de présider respectivement les commissions pour les Jeux  d’été et les Jeux d’hiver. Le 18 novembre, le CIO a dévoilé la composition de la commission qui aidera à l’organisation des Jeux d’hiver de Milano Cortina 2026. La Finlandaise Sari Essayah, olympienne et membre du CIO, présidera cette commission qui atteindra du coup la parité hommes-femmes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RECORDING O LYM P I C D R E A M S  Since 1932, OMEGA has known that the Olympic Games is a stage for dedicated athletes to reach their dreams. That’s why ZHORYHRXUUROHDV2IÿFLDO7LPHNHHSHUDQG why we’re so passionate about providing trusted precision in every single event."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:185px;left:262px;width:296px;height:52px\">\n          <img class=\"halfScale\" id=\"18-title-1\" src=\"/113/static/_content/18-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:189px;left:67px;width:154px;height:51px\">\n          <img class=\"halfScale\" id=\"18-title-2\" src=\"/113/static/_content/18-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:311px;left:604px;width:150px;height:49px\">\n          <img class=\"halfScale\" id=\"18-title-3\" src=\"/113/static/_content/18-title-3.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:701px;left:245px;width:504px;height:24px\">\n          <img class=\"halfScale\" id=\"18-title-4\" src=\"/113/static/_content/18-title-4.png\">\n        </div>\n\n      <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/bm_GheTJf9I')\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"width:45px; height:45px;left:524px;top:147px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n          <circle fill=\"none\" stroke=\"#FFF\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n          <polyline fill=\"#FFF\" points=\"558,356 207,563 207,117 \"/>\n        </svg>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.fromTo(idOf(\"18-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"18-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"18-title-3\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"18-title-4\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg18Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LANCEMENT DE LA MASCOTTE DE BEIJING 2022  PARIS 2024 DÉVOILE SON NOUVEL EMBLÈME  Un joyeux panda, baptisé Bing Dwen Dwen, sera la mascotte des Jeux d’hiver de 2022 à Beijing. «Bing» signifie glace et symbolise également la pureté et la force, alors que «Dwen Dwen» représente les enfants. Bing Dwen Dwen est habillé de glace et le cœur dessiné dans sa patte gauche évoque l’hospitalité du pays hôte. Les couleurs du cercle lumineux entourant son visage représentent les pistes de sports de glace et de neige. Elles sont aussi synonymes de connectivité et de technologies de pointe. «La mascotte intègre les meilleures caractéristiques de la Chine et de la population chinoise. Elle sera une merveilleuse ambassadrice de la Chine et des Jeux Olympiques d’hiver de Beijing 2022», a déclaré le président du CIO, Thomas Bach. Le comité d’organisation de Beijing 2022 a reçu plus de 5 800 dessins de mascottes. Les sélections finales ont été effectuées par des équipes de l’Académie des Beaux-Arts de Guangzhou et de l’Université Jilin des arts.  Le comité d’organisation des Jeux Olympiques et Paralympiques de Paris 2024 a dévoilé son nouvel emblème. Le motif associe trois symboles emblématiques qui renvoient au sport, aux Jeux et à la France: la médaille d’or, la flamme olympique et paralympique, et Marianne. L’emblème épouse la forme et la couleur de la médaille la plus convoitée pour exprimer l’une des valeurs fondamentales du sport: la quête de l’excellence. Cette  même ambition guide aussi Paris 2024 à chaque étape de l’organisation des Jeux Olympiques et Paralympiques, afin d’être à la hauteur des engagements pris d’offrir des Jeux différents, sobres, durables et inclusifs. Pour la première fois, l’emblème sera commun aux Jeux Olympiques et Paralympiques, avec pour seule distinction les anneaux olympiques pour l’un et les trois «agitos» paralympiques pour l’autre.  Ci-contre: l’emblème a été révélé au cinema Grand Rex à Paris.  Ci-dessous: des enfants ont pu rencontrer Bing Dwen Dwen lors de l'événement du lancement.  DES PROJETS D’HÉRITAGE À PYEONGCHANG En 2020, la Fondation pour l’héritage de PyeongChang 2018 commencera une série de programmes qui proposeront des activités toute l’année pour soutenir les legs sportifs et éducatifs des tout récents Jeux Olympiques d’hiver, et qui utiliseront les sites de PyeongChang et Gangneung. Outre des programmes d’entraînement pour les athlètes de haut niveau durant la saison d’hiver, un large éventail d’activités de loisirs et d’attractions touristiques sera proposé sur les sites olympiques hors saison. Le CIO donnera l’intégralité de sa part de l’excédent tiré de PyeongChang 2018, qui sera réinvestie dans diverses activités sportives et pour les jeunes. Ci-dessus: la Fondation pour l’héritage de PyeongChang 2018 réutilisera les sites olympiques.  500 000 CANDIDATS POUR LE RELAIS DE LA FLAMME Le comité d’organisation des Jeux Olympiques et Paralympiques de Tokyo 2020 a annoncé avoir reçu, à la clôture des inscriptions, 535 717 formulaires de particuliers espérant être choisis pour relayer la flamme olympique en vue des Jeux de Tokyo 2020.  18 REVUE OLYMPIQUE  De manière générale, le relais de la flamme olympique mettra en scène quelque 10 000 relayeurs, hommes, femmes et enfants venus d’horizons très divers. Les partenaires de présentation et les services préfectoraux présélectionneront les porteurs potentiels de la  flamme olympique sur la base des informations soumises par les candidats. Ils transmettront leurs recommandations au comité d’organisation de Tokyo 2020 qui fera alors son choix définitif. Les noms des candidats retenus seront annoncés en décembre."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:184px;left:66px;width:415px;height:53px\">\n          <img class=\"halfScale\" id=\"20-title-1\" src=\"/113/static/_content/20-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:674px;left:67px;width:424px;height:24px\">\n          <img class=\"halfScale\" id=\"20-title-2\" src=\"/113/static/_content/20-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:215px;left:616px;width:113px;height:23px\">\n          <img class=\"halfScale\" id=\"20-title-3\" src=\"/113/static/_content/20-sub.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(idOf(\"20-title-1\"), 0.6, {y:52}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"20-title-2\"), 0.6, {y:35}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"20-title-3\"), 0.6, {y:40}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg20Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LA GAISF LANCE UN TROPHÉE DE LA DURABILITÉ Le 23 septembre, l’Association mondiale des Fédérations Internationales de sports (GAISF) a lancé, dans le cadre de la Semaine d’action des Nations Unies pour la population et la planète, son nouveau Trophée de la durabilité. Ce prix doit inciter ses membres à utiliser leurs plateformes d’organisations sportives pour  participer de manière significative à la lutte contre le changement climatique mondial. Avec ce Trophée de la durabilité, qui sera décerné tous les ans lors de l’assemblée générale de la GAISF durant SportAccord, les FI qui ont œuvré en faveur de ces principes seront récompensées et recevront un trophée et un prix en espèces. Les candidats doivent soumettre un ensemble de documents démontrant leurs efforts en matière de durabilité. Les projets seront évalués par un jury bénévole  LA FIBA SE RÉUNIT À BEIJING En septembre, le nouveau Bureau central de la Fédération Internationale de Basketball (FIBA), élu pour la période 2019-2023, s’est réuni pour la première fois à Beijing (Chine) sous la présidence de son nouveau président, Hamane Niang. Deux nouveaux membres ont été cooptés: le Chinois Yao Ming et le Philippin Manuel V. Pangilinan. L’Allemand  20 REVUE OLYMPIQUE  Dirk Nowitzki a été nommé président de la commission des joueurs de la FIBA et l’Argentin Horacio Muratore a été nommé président de la Fondation internationale de basketball, après avoir passé cinq années à la tête de la FIBA (2014-2019). À droite: Hamane Niang, le nouveau président du Bureau central de la FIBA.  d'experts reconnus de diverses organisations internationales. «Le Trophée de la durabilité est une indication de notre engagement à utiliser le sport comme un vecteur de changements mondiaux significatifs», a déclaré Raffaele Chiulli, le président de la GAISF. «J’ai hâte de découvrir les idées et solutions innovantes mises en œuvre par nos FI.» Ci-contre: le Trophée de la durabilité sera présenté à Beijing, ville hôte de SportAccord en 2020.  EN BREF La FIH participe à une conférence de l’ONU En septembre dernier à Vienne (Autriche), la Fédération Internationale de Hockey FIH) a participé à une conférence, donnée par les Nations Unies sur la protection du sport contre la corruption, la drogue et le crime. Elle a évoqué les leçons tirées de ses efforts de renforcement de la bonne gouvernance et de l’intégrité au sein du hockey. Valérie Horyna, conseillère juridique senior de la FIH, a commenté le programme antidopage de la FIH, sa politique en faveur de l’égalité des sexes et les autres programmes que la FIH met en œuvre actuellement au sein du sport. Troisième Journée mondiale de l’escrime Les escrimeurs du monde entier ont participé à la troisième Journée mondiale annuelle de l’escrime, le 7 septembre, en prodiguant bonne volonté, durabilité et gestes humanitaires. Le thème «L’escrime pour notre planète» mettait en exergue des projets destinés à favoriser la protection de l’environnement, aider ceux qui en ont besoin et pratiquer des politiques de durabilité dans les clubs et les tournois."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:548px;left:229px;width:319px;height:68px\">\n          <img class=\"halfScale\" id=\"21-title-1\" src=\"/113/static/_content/21-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:186px;left:50px;width:149px;height:51px\">\n          <img class=\"halfScale\" id=\"21-title-2\" src=\"/113/static/_content/21-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:323px;left:587px;width:150px;height:59px\">\n          <img class=\"halfScale\" id=\"21-title-3\" src=\"/113/static/_content/21-title-3.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:544px;left:587px;width:149px;height:46px\">\n          <img class=\"halfScale\" id=\"21-title-4\" src=\"/113/static/_content/21-title-4.png\">\n        </div>\n\n      <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/-_t6Kt2VB_Y')\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"width:45px; height:45px;left:493px;top:204px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n          <circle fill=\"none\" stroke=\"#FFF\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n          <polyline fill=\"#FFF\" points=\"558,356 207,563 207,117 \"/>\n        </svg>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(idOf(\"21-title-1\"), 0.6, {y:70}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"21-title-2\"), 0.6, {y:53}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"21-title-3\"), 0.6, {y:53}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"21-title-4\"), 0.6, {y:53}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg21Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LE CNO BRÉSILIEN RENFORCE LA LUTTE CONTRE LE DOPAGE  CHINESE TAIPEI PROMEUT LES FEMMES DANS LE SPORT  En septembre, le Comité National Olympique brésilien a présenté les détails de son programme de prévention et d’éducation autour du dopage. L’objectif est de développer la sensibilisation et l’information pour protéger les athlètes et étendre l’accès à l’éducation à l’antidopage dès les premiers stades du développement de l’athlète olympique. Outre des journalistes et des leaders d’opinion, des collaborateurs du CIO et des représentants d’institutions partenaires du système antidopage brésilien ont assisté à cette présentation au siège du CNO. Le champion olympique de judo en 1992 Rogério Sampaio, directeur général du CNO, a ouvert la manifestation tandis que la présentation du programme a été effectuée par Christian Trajano, responsable de la prévention du dopage et de l’éducation au sein du CNO. «La question de l’éducation et de la prévention du dopage est très importante», a souligné ce dernier. Ci-dessus: Christian Trajano présente le programme du CNO.  La 5e Conférence Internationale sur les femmes et le sport, organisée par le CNO de Chinese Taipei, a eu lieu à Taipei les 10 et 11 septembre. Le thème, «Les femmes artisanes du développement durable dans le sport», portait sur l’autonomisation et le leadership des femmes, la promotion de la santé et la pratique du sport en toute sécurité.  LE MUSÉE OLYMPIQUE DU JAPON OUVRE SES PORTES À TOKYO Le 14 septembre, le Musée Olympique du Japon, situé près du stade olympique national, a ouvert ses portes. Le musée est géré par le Comité National Olympique japonais et il propose des expositions tout à fait passionnantes où les visiteurs peuvent découvrir l’histoire et la signification du Mouvement olympique. Ils peuvent avoir des informations sur les différentes éditions des Jeux qui se sont déroulées au Japon mais aussi sur les Jeux de Tokyo 1940, annulés en raison du déclenchement de la Seconde Guerre mondiale. À l’extérieur, les visiteurs peuvent déambuler dans  l’espace des monuments où sont rassemblées les vasques olympiques des Jeux de Tokyo 1964, Sapporo 1972 et Nagano 1998. Ci-dessus: le Musée Olympique du Japon a ouvert ses portes au public.  LE CNO ARGENTIN TIENT UN SÉMINAIRE SUR L’OLYMPISME Le 21 septembre, le CNO argentin a tenu un séminaire sur l’Olympisme qui a réuni 120 participants de différentes provinces ainsi que 20 conférenciers. Parmi eux figuraient deux médaillés olympiques, des enseignants, des chercheurs, universitaires et des dirigeants sportifs. Le séminaire était axé sur l’importance des valeurs dans le sport de compétition et de loisirs et leur gestion. Le séminaire était placé sous la direction de la commission de l’éducation et de l’Académie olympique du CNO que préside Carlos Alberto Marino, et était conduit par Silvia Dalotto Marcó, directrice de l’Académie.  REVUE OLYMPIQUE 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:508px;left:66px;width:472px;height:45px\">\n          <img class=\"halfScale\" id=\"22-title-1\" src=\"/113/static/_content/22-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:325px;left:604px;width:147px;height:45px\">\n          <img class=\"halfScale\" id=\"22-title-2\" src=\"/113/static/_content/22-title-2.png\">\n        </div>\n\n      <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/ev1OKMOtnaA')\" target=\"_blank\">\n        <svg class=\"abs pulse animatedpulse pointer\" style=\"width:35px; height:35px;left:537px;top:512px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n          <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n          <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n        </svg>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(idOf(\"22-title-1\"), 0.6, {y:85}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"22-title-2\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg22Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "DAKAR 2022 SUR LA BONNE VOIE POUR ACCUEILLIR LES JOJ  le dernier jour du Sommet. Suivra une séance de questions-réponses entre le président et les jeunes leaders du CIO. «Le Sommet de la jeunesse organisé par le CIO est toujours un temps fort de l’année, car il est très motivant de voir des jeunes gens créatifs autant attachés aux valeurs olympiques. Tous se sont épanouis au fil des années et ils jouent maintenant un rôle encore plus important dans le cadre du processus décisionnel du CIO», a déclaré le président Bach, qui a nommé 16 jeunes leaders au sein des commissions du CIO en 2019, contre 7 en 2018.  L’équipe de Dakar 2022 a échangé avec des représentants de la commission de coordination du CIO, lors de la première visite de celle-ci dans la capitale sénégalaise depuis l’attribution des 4es JOJ d’été. Au cours d’une visite de trois jours en octobre, le CIO et Dakar 2022 ont passé en revue tous les aspects des préparatifs. Parmi les points saillants, citons la présentation par un groupe de travail spécifique des réflexions qui permettront de réaliser la vision, la mission et les objectifs, ainsi qu’un plan d’héritage ambitieux qui garantira que les JOJ profiteront à la ville, au pays et au continent tout entier longtemps après la fin des Jeux. «Il est exaltant de voir le premier événement olympique organisé en Afrique prendre forme devant nos yeux», a dit Nawal El Moutawakel, membre du CIO au Maroc, qui siège à la commission de coordination des JOJ de Dakar 2022. «Toutes les équipes ont fait de gros progrès en lien avec leur objectif de présenter un Sénégal moderne et dynamique à travers les JOJ de Dakar 2022.»  Ci-dessus: des participants à un atelier de «createathon» du CIO, à l’université de Lausanne.  Ci-dessus: vue aérienne de l’arène nationale de lutte qui servira de site pour Dakar 2022.  LES JEUNES LEADERS DU CIO PARTICIPENT AU PREMIER «CREATEATHON» La 4e édition du Sommet de la jeunesse du CIO s'est déroulée du 6 au 8 septembre, à Lausanne. Cinquante-trois jeunes leaders du CIO, baptisés jusque-là Young Change-Makers, se sont retrouvés pour mettre à l’épreuve leur créativité dans le cadre du tout premier «createathon» en vue des prochains JOJ d’hiver. Le createathon a réuni dix équipes de jeunes leaders, qui ont eu pour tâche de créer un espace du CIO interactif et immersif, qui devrait accueillir 100 000 fans durant les JOJ de Lausanne 2020. Au cours de ce marathon de huit heures, les jeunes leaders du CIO ont travaillé en étroite coopération et dans le plus pur esprit olympique au sein de leur équipe respective, laissant libre cours à leur imagination pour  22 REVUE OLYMPIQUE  élaborer des concepts ludiques et immersifs associant sport et culture. Tous les projets étaient axés sur le respect des valeurs olympiques au quotidien. Les jeunes leaders ont été encadrés par un groupe de formateurs et par plus de 20 spécialistes en narration, réalité virtuelle, réseaux sociaux, architecture et design. Les équipes avaient trois minutes pour présenter leur projet à un jury composé d’experts et placé sous la conduite de Virginie Faivre, présidente de Lausanne 2020. Les membres du jury ont examiné les propositions soumises sur la base de leur faisabilité, de leur créativité et de la prestation des groupes. Les trois meilleures équipes ont été invitées à exposer leur concept au président du CIO, Thomas Bach,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:202px;left:267px;width:433px;height:90px\">\n          <img class=\"halfScale\" id=\"24-title-1\" style=\"top:20px\" src=\"/113/static/_content/24-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:165px;left:267px;width:273px;height:36px\">\n          <img class=\"halfScale\" id=\"24-title-2\" src=\"/113/static/_content/24-title-2.png\">\n        </div>\n        <img class=\"halfScale\" id=\"24-sub-1\" style=\"top:303px;left:266px;\" src=\"/113/static/_content/24-sub-1.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(idOf(\"24-title-1\"), 0.6, {y:-125}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"24-title-2\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"24-sub-1\"), 0.6, {y:35, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OPINION  AU-DELÀ DES ANNEAUX  LAUSANNE CULTIVE L’OLYMPISME GRÉGOIRE JUNOD, SYNDIC DE LAUSANNE, EXPLIQUE COMMENT LES JEUX OLYMPIQUES DE LA JEUNESSE D’HIVER VONT SERVIR DE SOURCE D’INSPIRATION AUX JEUNES DE LA CAPITALE OLYMPIQUE ET VONT AVOIR UN IMPACT POSITIF SUR LA RÉGION HÔTE.  L  a ville de Lausanne vit une période historique sur le plan sportif. Avec l’accueil des Jeux Olympiques de la Jeunesse (JOJ) Lausanne 2020, c’est toute la ville et sa région qui sont en ébullition. Grâce à l’attribution de ces Jeux il y a quatre ans, la patinoire de la Vaudoise aréna a pu voir le jour en un temps record, permettant de réaliser une infrastructure ultramoderne pour tout le canton, faisant partie intégrante du projet de développement «Métamorphose» de la ville. Les compétitions de plusieurs sports de glace, ainsi que la cérémonie d’ouverture et de clôture, auront lieu dans un décor flambant neuf. Avec le lancement de ces JOJ d’ici quelques semaines, la capitale olympique deviendra ville hôte olympique à part entière. Accueillir des jeunes athlètes du monde entier, leur offrir des infrastructures à la hauteur de l’événement, vibrer avec eux, et vivre avec l’ensemble de la population et du public de grands moment... C’est une chance inouïe, une aventure qui marquera la région pour très longtemps. Cette manifestation de grande envergure va permettre de mettre à l’honneur deux facteurs d’identité essentiels de la ville: le sport et la culture. Capitale olympique depuis 25 ans, capitale administrative du sport mondial et ville de culture avec des institutions reconnues sur le plan international, la ville de Lausanne souhaite saisir cette chance de renforcer les collaborations entre ces deux univers. Avec l’organisation durant les JOJ de la  24 REVUE OLYMPIQUE  manifestation «Lausanne en Jeux!» la ville crée un formidable laboratoire pour expérimenter cette rencontre et cultiver sur le long terme ce qu’elle aura semé. Ainsi, un programme ambitieux mêlant concerts, spectacles, initiations sportives et activités pédagogiques sur le thème du sport permettra de faire de ces jeux un moment de fête pour l’ensemble de la population. Les Jeux Olympiques de la Jeunesse de Lausanne 2020, c’est bien sûr l’opportunité de mettre en lumière le dynamisme et l’inventivité de la jeune génération de la région, et de l’impliquer dans l’organisation de cet événement majeur. À ce titre,  la mise sur pied des JOJ de Lausanne 2020 et de la manifestation «Lausanne en Jeux!» est d’ores et déjà une réussite, de par l’énergie qu’elle a générée au sein des écoles et des lieux de formation ainsi que des nombreux projets réalisés. Ici à Lausanne, les JOJ s’inscrivent dans une politique globale menée par la municipalité en faveur des enfants et de la jeunesse, et c’est avec impatience que, tous ensemble, nous comptons les jours jusqu’à la cérémonie d’ouverture! ■ Grégoire Junod est syndic de Lausanne depuis 2016.  À gauche: les organisateurs ont travaillé en étroite collaboration avec la ville de Lausanne pour préparer les JOJ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:799px;left:379px;height:21px;width:139px;\">\n            <a href=\"https://www.intel.fr/content/www/fr/fr/sports/olympic-games/overview.html\" target=\"_blank\"></a>\n        </div>",
    "script": "\n        function onPageEnter() {\n            setTimeout(function(){\n                addContentLinks();\n            },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "AMAZING AHEAD Intel is proud to be a worldwide partner of the Olympic Games and to play a key role in accelerating the adoption of new technologies like drones, virtual reality, 5G, and artificial intelligence platforms. Together with partners, we are creating Olympic experiences that are more innovative and immersive than ever before. Learn more at intel.com/olympics  © Intel Corporation. Intel and the Intel logo are trademarks of Intel Corporation or its subsidiaries in the U.S. and/or other countries."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n    \n        function onPageLeave() {\n        }\n      ",
    "searchText": "WOMEN IN SPORT  Ci-contre: le ski freestyle à Leysin est l’une des nombreuses épreuves qui vont séduire le public lors de ces Jeux.  26 REVUE OLYMPIC OLYMPIQUE REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"27-title-1\" style=\"top:173px;left:63px;\" src=\"/113/static/_content/27-title.png\"> \n      <img class=\"halfScale\" id=\"27-title-2\" style=\"top:243px;left:512px;\" src=\"/113/static/_content/27-sub.png\"> \n      ",
    "script": "\n      function onPageEnter() {\n        pg27Anim = new TimelineMax();\n        pg27Anim.fromTo(idOf(\"27-title-1\"), 0.6, {y:-125, opacity: 0}, {y:0, opacity: 1, ease: Power2.easeOut}, 1)\n        .fromTo(idOf(\"27-title-2\"), 0.6, {y:50, opacity: 0}, {y:0, opacity: 1, ease: Power2.easeOut}, \"-=0.3\")\n\n      }\n  \n      function onPageLeave() {\n        pg27Anim.stop();\n      }\n      ",
    "searchText": "LAUSANNE 2020  C’EST ICI QUE TOUT COMMENCE  LA CAPITALE OLYMPIQUE SE PRÉPARE À ACCUEILLIR LES 3es JEUX OLYMPIQUES DE LA JEUNESSE D’HIVER. L’OCCASION POUR ANNESHA GHOSH D’EXAMINER LES CONCEPTS NOVATEURS MIS EN ŒUVRE POUR LAUSANNE 2020, ALORS QUE LES ATHLÈTES ET LES FANS DEVRAIENT BÉNÉFICIER D’UN FESTIVAL EXTRAORDINAIRE DE SPORT POUR LES JEUNES ET DE CULTURE MODERNE.  REVUE OLYMPIC OLYMPIQUE REVIEW 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      <svg onclick=\"Publish.openGallery(['28-gal-1.jpg', '28-gal-2.jpg', '28-gal-3.jpg', '28-gal-4.jpg', '28-gal-5.jpg', '28-gal-6.jpg', '28-gal-7.jpg', '28-gal-8.jpg', '28-gal-9.jpg'])\" class=\"abs pointer pulse animatedpulse \"style=\"left:62px;width:70px; top:89px; height:70px;\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\">\n          <g>\n            <path fill=\"#c40179\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"/>\n            <path fill=\"#c40179\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n              M123.685,63.134h-20.209v-5.966h20.209V63.134z\"/>\n          </g>\n          <g>\n            <path fill=\"#c40179\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n              L154.856,78.867z\"/>\n          </g>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LAUSANNE 2020  I  l y a 25 ans, la ville de Lausanne est devenue «capitale olympique», un titre qui lui a été décerné lors des célébrations du centenaire de l’un de ses résidents les plus célèbres: le Comité International Olympique (CIO). Le 9 janvier 2020, Lausanne fera ses débuts en tant que ville hôte olympique, avec l’ouverture des 3es Jeux Olympiques de la Jeunesse (JOJ) d’hiver, coup d’envoi d’une année tournée vers l’Olympisme. À six mois des Jeux de Tokyo 2020, la cérémonie d’ouverture des JOJ d’hiver de Lausanne 2020 concrétisera le retour d’un événement olympique en Suisse presque 72 ans plus tard. Dans l’enceinte de sa Vaudoise aréna flambant neuve, Lausanne s’attachera, en fanfare et feux d’artifice, à appliquer la philosophie cosmopolite qui consolide sa fondation en tant que siège du CIO. Inaugurant l’équilibre hommesfemmes, pour la première fois à un événement olympique d’hiver, 1 880 athlètes de 80 pays concourront dans huit sports et seize disciplines au cours de ces JOJ de Lausanne 2020. Durant 13 jours, 81 épreuves se dérouleront sur huit sites situés à Lausanne, dans trois cantons suisses et une région française voisine. Selon Pierre de Coubertin, fondateur du Mouvement olympique moderne, Lausanne était «le lieu le plus apte qu’on puisse imaginer pour établir le siège administratif de l’Olympisme». Nichée sur les rives du lac Léman, dans un écrin montagneux de carte postale, la ville s’est réinventée à de nombreuses reprises, et elle est devenue le siège de plus de 60 Fédérations Internationales et organisations sportives. Lausanne, qui s’étend sur plus de 41 km2, est autant réputée pour son splendide environnement naturel que pour les rues pentues qui mènent à la cathédrale du XIIe siècle de la cité. Caractérisée par le charme de sa vieille ville, Lausanne est également largement reconnue pour ses efforts avant-gardistes en matière de développement durable. En effet, elle a notamment signé la charte des villes européennes pour le développement durable et a reçu le label European Energy Award® Gold. L’engagement de la ville  28 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"29-quote\" style=\"top:570px;left:567px;\" src=\"/113/static/_content/29-quote.png\">  \n\n        <div class=\"addContentLink\" style=\"top:680px;left:550px;height:230px;width:183px;\">\n            <a href=\"https://www.olympic.org/fr/news/en-route-pour-lausanne-2020-avec-ana-noelle-reynado-wahleithner-en-passe-de-devenir-la-premiere-philippine-a-participer-aux-joj-en-sports-d-hiver\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(idOf(\"29-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n    \n        function onPageLeave() {\n          pg29Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "hôte en matière de durabilité sera également perceptible aux JOJ. Lausanne 2020 a collaboré avec les «TL», le réseau des transports publics de la ville, afin d’inciter à l’usage des transports en commun durant les grands événements, tout en organisant des actions de nettoyage comme des «plogging», un concept suédois qui combine le jogging avec le ramassage des détritus, à travers toute la ville. Soulignant l’engagement à la durabilité du comité d’organisation de Lausanne 2020, pour la première fois de l’histoire olympique, la vasque de la flamme sera alimentée de manière éco-responsable. Ainsi, cette vasque olympique met en exergue le souci de Lausanne 2020 de créer des Jeux durables et novateurs, en faisant appel à l’expertise et au savoir-faire locaux. Elle a été conçue par l’École cantonale d’art de Lausanne (ECAL), une école d’art locale, et fabriquée en collaboration avec les apprentis et les étudiants de trois établissements scolaires de Lausanne. La vasque bénéficiera d’un système de combustion mis au point par Lignum Vaud, la communauté d’action régionale de Lignum Économie Suisse du Bois. La flamme est en effet alimentée Ci-dessus: Lausanne 2020 compte séduire les jeunes. À gauche: une série de séances de “plogging” se tiendront en amont des JOJ d’hiver.  «Je ne tiens plus en place à l’idée d’aller à Lausanne. J’ai hâte de représenter les Philippines, c’est très important et c’est un honneur pour moi.»  Ci-contre: vue aérienne du centre alpin des Diablerets.  ANA NOELLE WAHLEITHNER (PHI), SKI ALPIN"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {}\n        function onPageLeave() {}\n      ",
    "searchText": "LAUSANNE 2020  Ci-contre: les supporters regardent une épreuve à l’halfpipe de Leysin avant les JOJ.  30 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n      <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/as5I3egQJhc')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:673px;top:770px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "",
    "searchText": "LAUSANNE 2020  Enracinée dans l’approche de Lausanne 2020, qui est de favoriser une appropriation renouvelée des valeurs olympiques par la jeunesse locale, l’idée de JOJ «pour les jeunes, par les jeunes et avec les jeunes» sous-tend l’ensemble du projet. Près de 130 000 élèves des écoles, collèges et universités de la région ont déjà contribué à l’élaboration de ces 3es JOJ d’hiver, conçu certains des éléments clés de ces Jeux comme les plateaux des médailles, les podiums et les 16 pictogrammes illustrant les différentes disciplines des huit sports au programme de Lausanne 2020. Des étudiants d’une école d’art de Lausanne 2020 se sont également chargés de créer la mascotte officielle, par des pellets de bois suisse au lieu du gaz, qui ne nécessiteront qu’un chargement par jour. «Pour le comité d’organisation de Lausanne 2020 et les Suisses, le fait qu’un événement olympique ait lieu de nouveau en Suisse pour la troisième fois fait l’objet de beaucoup de considération, de même que l’accent mis sur la durabilité parmi les principaux concepts des Jeux», explique Ian Logan, le directeur général de Lausanne 2020. «Cette année marque le 125e anniversaire du CIO. Avec le déroulement des Jeux Olympiques de la Jeunesse d’hiver ici en 2020, on sent le pouvoir de l’Olympisme s’étendre dans toute la Suisse. Organiser les JOJ pour la première fois dans le pays aura un impact énorme sur notre héritage sportif car l’engagement et l’enthousiasme des gens aident à promouvoir l’Olympisme.»  Ci-dessus: Yodli, mascotte ofﬁcielle, accueille les jeunes de la région avec Sarah Atcho, athlète suisse et ambassadrice de Lausanne 2020. À droite: les pictogrammes de Lausanne 2020 (ci-dessus) et les podiums (ci-dessous) ont été conçus par les écoles d’art de la région.  REVUE OLYMPIQUE 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"32-quote\" style=\"top:587px;left:83px;\" src=\"/113/static/_content/32-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n            pg32Anim = new TimelineMax();\n            pg32Anim.fromTo(idOf(\"32-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n            pg32Anim.stop();\n            removeContentLinks();\n        }\n      ",
    "searchText": "LAUSANNE 2020  Yodli, croisement de trois animaux suisses emblématiques – vache, chèvre et saint-bernard –, qui incarne la diversité des participants de ces 3es JOJ d’hiver. En outre, des écoliers de la région ont composé la musique de la cérémonie de remise des médailles et la chanson officielle des Jeux. Cette dernière a été réalisée via un concours remporté par Gaspard Colin, élève de la Haute école de musique de Lausanne. «Lausanne 2020 souhaite que les jeunes soient acteurs et non pas seulement spectateurs des Jeux», explique Stefany Chatelain-Cardenas, directrice responsable des projets d’engagement de la jeunesse à Lausanne 2020. «C’est pourquoi nous collaborons avec les écoles depuis 2016 pour que les étudiants et les apprentis participent aux Jeux à travers divers projets et activités éducatifs et sportifs.» Par ailleurs, 53 jeunes dirigeants du CIO, connus précédemment sous le nom de Jeunes artisans du changement (Change-makers), marquent également Lausanne 2020 de leur empreinte, en participant à la conception d’un espace d’immersion interactif du CIO dans le pôle de sites de Malley. La sensibilisation de la jeunesse recevra un coup de pouce supplémentaire  «Je suis vraiment très heureux. Ça va être génial de faire partie de l’équipe néo-zélandaise et j’ai hâte de concourir à Lausanne.»  CAMPBELL WRIGHT (NZL), BIATHLON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LAUSANNE 2020  grâce aux prometteurs festivals «En Jeux!» qui permettront aux spectateurs de tester eux-mêmes des sports olympiques de la jeunesse sur les huit sites d’accueil. La capitale olympique elle-même donnera le ton de la fête en organisant le principal festival «Lausanne En Jeux!», un programme comprenant des initiations sportives et des manifestations culturelles en parallèle des compétitions sportives. L’accès à toutes les épreuves sportives et au festival sera gratuit. En tant que centre principal des Jeux, Lausanne accueillera l’un des deux villages olympiques de la jeunesse, la plaza des médailles, les cérémonies d’ouverture et de clôture, et l’ensemble des compétitions de glace, notamment une épreuve de hockey sur glace 3 x 3 par équipes  Ci-dessus: une épreuve de ski alpin en amont des JOJ aux Diablerets. À gauche: une équipe de jeunes dirigeants du CIO soutiendra les athlètes. Ci-contre: les épreuves de glisse auront lieu sur une piste de glace naturelle à Saint-Moritz.  REVUE OLYMPIQUE 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/Jjj8Y_DIo1M')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:282px;top:487px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          \n        }\n    \n        function onPageLeave() {\n          pg34Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LAUSANNE 2020  regroupant plusieurs nationalités, inscrite au programme olympique pour la première fois. D’autres sports et disciplines feront également leurs débuts olympiques, comme les épreuves féminines de luge en double et de combiné nordique, et le ski alpinisme. Par ailleurs, la station alpine de SaintMoritz, où ont eu lieu les Jeux Olympiques d’hiver de 1928 et de 1948, abritera le deuxième village olympique des JOJ ainsi que des épreuves de glisse sur l’«Olympia Bob Run» à Saint-Moritz-Celerina, la dernière et la plus ancienne piste de bobsleigh sur glace naturelle du monde. Le patinage de vitesse aura pour cadre le spectaculaire lac gelé de la station. Continuant à mettre fortement l’accent Ci-dessus, à gauche: l’anneau où aura lieu le patinage de vitesse à Saint-Moritz. Ci-dessus: le Vortex se transformera en logements pour étudiants après les JOJ d’hiver. À gauche: la Vaudoise aréna sera utilisée par la suite pour les Championnats du monde de hockey sur glace 2020.  34 REVUE OLYMPIQUE  sur la durabilité, Lausanne 2020 utilisera des installations et des équipements existants, non seulement en Suisse, mais aussi en France voisine, donnant ainsi naissance aux premiers Jeux binationaux de l’histoire. Quant aux installations nouvelles ou rénovées qui seront utilisées, comme l’immeuble du Vortex qui servira de village olympique de la jeunesse ou la Vaudoise aréna qui accueillera les rencontres de hockey sur glace, ces améliorations faisaient déjà partie des projets de développement à long terme de la région hôte. L’une des principales caractéristiques de Lausanne 2020 est son système d’organisation en deux vagues – une solution novatrice conçue pour augmenter la capacité d’hébergement en permettant à chaque “vague” d’athlètes d’effectuer un séjour plus court sur place. Ainsi, 1 880 athlètes au total pourront participer"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n      <a href=\"https://www.startyourimpossible.com/fr-fr/?__geom= \" target=\"_blank\">\n          <div class=\"contentLink addContentLink\" style=\"top:39px;left:684px;width:94px;height:16px\"></div>\n        </a>\n      ",
    "script": "\n      function onPageEnter() {\n        setTimeout(function(){\n          addContentLinks();\n        },1000)\n      }\n\n      function onPageLeave() {\n        removeContentLinks();\n      }\n      ",
    "searchText": "MobilityForAll.com  W H E N W E A R E F R E E TO M OV E , A N Y T H I N G I S P O S S I B L E ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"36-quote\" style=\"top:583px;left:85px;\" src=\"/113/static/_content/36-quote.png\">\n      <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/h8MEPIBrKvc')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:85px;top:185px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n        ",
    "script": "\n        function onPageEnter() {\n            pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(idOf(\"36-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n            pg36Anim.stop();\n        }\n      ",
    "searchText": "ONE YEAR TO LAUSANNE 2020 GO  « Depuis les JOJ de Lillehammer, j’ai toujours voulu aller à Lausanne. C’était comme un rêve.»  Ci-dessus: le voyage de la ﬂamme a fait monter l’enthousiasme pour Lausanne 2020. À droite: Olympic Channel présentera le ski alpinisme à un nouveau public.  LUKAS HØSTMÆLINGEN (NOR), CURLING  aux Jeux Olympiques, contre 1 100 à Lillehammer 2016, avec une représentation à parité de 940 hommes et 940 femmes, ce qui permettra une diversité exemplaire et des compétitions de très grande qualité. Au cours de ces JOJ, ces jeunes athlètes seront pris en charge par une équipe d’athlètes modèles (ARM) représentant chaque sport du programme et composée d’olympiens et de champions du monde. Ces ARM entreront en contact avec les participants par le biais d’une série d’activités éducatives et d’ateliers, comme les séances très prisées de questions-réponses «Discussions avec les champions», qui proposent soutien, assistance et conseils sur tous les aspects de la carrière d’un athlète de haut niveau. Les préparatifs des 3es JOJ d’hiver touchent à leur fin et la flamme olympique de la jeunesse a déjà entamé son voyage  qui traversera les 26 cantons suisses, avant de rejoindre la cérémonie d’ouverture le 9 janvier. Lorsqu’elle arrivera, la nouvelle génération de stars olympiques de la jeunesse sera déjà prête à entrer en scène, tandis que les JOJ, en constante évolution, offriront des souvenirs impérissables pour les fans. ■ Annesha Ghosh est journaliste multimédia à ESPN (Inde). Elle était jeune reporter du CIO aux JOJ de Buenos Aires 2018 et elle occupera la même fonction à Lausanne 2020. DANS LE PROCHAIN NUMÉRO: la Revue Olympique revient sur les temps forts des JOJ d’hiver de Lausanne 2020, des performances des jeunes «Game Changers» aux initiatives éducatives et culturelles qui ont eu lieu hors des sites."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"37-title\" style=\"top:165px;left:92px;\" src=\"/113/static/_content/37-title.png\">\n\n      <h1 id=\"37-no\" class=\"abs 37-no hn-bd\" style=\"left: 588px; top: 263px; font-size: 2.3em; font-family: HelveticaNeueLTPro-Bd; font-weight: 700; color: rgb(196, 0, 120); padding: 0px; margin: 0px; opacity: 1;\" data-number=\"{&quot;to&quot;: 300 }\"></h1>\n      \n      <div class=\"addContentLink\" style=\"top:160px;left:90px;height:35px;width:405px;\">\n        <a href=\"https://www.olympicchannel.com/fr/stories/news/detail/lausanne-2020-winter-youth-olympics-schedule/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n            pg37Anim = new TimelineMax();\n          pg37Anim.fromTo(idOf(\"37-title\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n          .fromTo(cOf(\"37-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"37-no\")[0]);}}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n            pg37Anim.stop();\n            removeContentLinks();\n        }\n      ",
    "searchText": "Olympic Channel effectuera une large couverture de la troisième édition des JOJ d’hiver du 9 au 22 janvier 2020, avec une diffusion en continu et à la demande, une chaîne spéciale consacrée aux JOJ, un programme en direct quotidien et les podcasts d’Olympic Channel. Cette couverture multiplateforme sera disponible sur les territoires du monde entier. Elle débutera le 9 janvier par la cérémonie d’ouverture en direct depuis Lausanne, la capitale olympique. Au fil des 13 jours de compétition, de nouvelles disciplines telles que le ski alpinisme et le hockey  3 x 3 seront retransmises sur la chaîne à côté des autres têtes d’affiche passionnantes des JOJ d’hiver que sont notamment le ski alpin et le snowboard. Mary Byrne, rédactrice en chef de la chaîne, estime que «la couverture de Lausanne 2020 par Olympic Channel garantira une audience mondiale aux JOJ et donnera le coup d’envoi à une année importante pour notre équipe, tandis que notre couverture quotidienne des sports et athlètes olympiques continuera de se développer  à l’approche des prochains Jeux Olympiques d’été de Tokyo 2020». ■ Suivez la couverture de Lausanne 2020 sur olympicchannel.com, ses applications mobiles et les appareils connectés ainsi que sur les plateformes de réseaux sociaux.  300  heures de couverture par Olympic Channel  REVUE OLYMPIQUE 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"38-title\" style=\"top:223px;left:67px;\" src=\"/113/static/_content/38-title.png\">  \n        <img class=\"halfScale\" id=\"38-sub\" style=\"top:308px;left:66px;\" src=\"/113/static/_content/38-sub.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(idOf(\"38-title\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n          pg38Anim.fromTo(idOf(\"38-sub\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"=-0.3\")\n        }\n    \n        function onPageLeave() {\n          pg38Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LAUSANNE 2020  «LES JOJ SONT FAITS POUR ET PAR LES JEUNES» LA PRÉSIDENTE DU COMITÉ D’ORGANISATION DE LAUSANNE 2020, VIRGINIE FAIVRE, ANCIENNE CHAMPIONNE DU MONDE SUISSE DE SKI ACROBATIQUE, FAIT PART À LA REVUE OLYMPIQUE DE SES ATTENTES PAR RAPPORT AUX 3es JOJ D’HIVER. ELLE EXPLIQUE POURQUOI ILS MONTRERONT LA VOIE EN MATIÈRE D’ORGANISATION ET D’ÉVÉNEMENTS SPORTIFS DURABLES.  Ci-dessous: Virginie Faivre s’adresse à plus de 3 000 écoliers lors de la cérémonie des drapeaux.  Quel est votre rôle en tant que présidente du comité d’organisation de Lausanne 2020? Depuis que j’ai repris le rôle de présidente de Lausanne 2020 en janvier 2019, les journées se sont succédé, toutes différentes. Généralement, mon rôle consiste à représenter Lausanne 2020 et à transmettre nos idéaux au monde: engagement de la jeunesse, innovation, durabilité et Olympisme. Que je rende compte de notre progression à la Session du CIO ou que je passe l’après-midi à skier dans une station de la région avec des écoliers, mon but est d’être la meilleure ambassadrice de Lausanne 2020 et de ﬁxer les orientations de ce projet exceptionnel.  Qu’espérez-vous réaliser à Lausanne 2020 pour que ces Jeux soient un succès? Les JOJ sont faits pour et par les jeunes. Il s’agit de favoriser et de développer de nouveaux talents. L’une de nos priorités concerne le sport de compétition. Nous devons soutenir les jeunes athlètes et leur donner les outils nécessaires à la suite de leur carrière sportive. Le secteur du sport compte de nombreux emplois et ces jeunes athlètes doivent pouvoir s’épanouir et maîtriser les compétences qu’ils acquièrent aux JOJ. Ils pourront les mettre à proﬁt dans leurs futures professions d’entraîneurs, de médecins ou de dirigeants. Nous devons démontrer les atouts qu’offre le sport.  Que fait le comité d’organisation de Lausanne 2020 pour rendre les JOJ durables? Les JOJ de Lausanne 2020 ont été entièrement conçus avec la durabilité à l’esprit, des sites à la vasque olympique. Les sites de compétition ont été choisis pour tirer parti des structures existantes et des paysages naturels, réduire au minimum les installations temporaires et laisser un héritage durable grâce à des rénovations, à condition que ces dernières soient nécessaires à l’utilisation ultérieure de la population locale. L’histoire de notre site de patinage de vitesse est également éloquente: plutôt que de construire une grande infrastructure ou une structure temporaire pour cette épreuve, nous sommes parvenus à obtenir l’approbation du CIO et de l’Union internationale de patinage (ISU) pour utiliser le spectaculaire lac gelé de Saint-Moritz. Tout le monde est ravi de cette solution, car elle tire le meilleur parti de l’expertise locale. Pouvez-vous nous en dire plus sur les innovations mises en œuvre par Lausanne 2020? Une combinaison intelligente de solutions durables et d’innovations, tel est le thème central de Lausanne 2020. En soi, le format de ces Jeux sera différent par sa nouvelle approche en matière d’accueil des athlètes et des délégations en deux vagues. Cela permettra des séjours plus courts et une augmentation du nombre d’athlètes, ce qui relèvera la qualité des  38 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"39-quote\" style=\"top:374px;left:550px;\" src=\"/113/static/_content/39-quote.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n            pg39Anim = new TimelineMax();\n            pg39Anim.fromTo(idOf(\"39-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n            pg39Anim.stop();\n        }\n      ",
    "searchText": "LAUSANNE 2020  «NOUS DEVONS SOUTENIR LES JEUNES ATHLÈTES QUI FONT LEURS DÉBUTS ET LEUR DONNER LES OUTILS NÉCESSAIRES À LA SUITE DE LEUR CARRIÈRE SPORTIVE.» VIRGINIE FAIVRE, PRÉSIDENTE DE LAUSANNE 2020 compétitions. Plusieurs épreuves feront leurs débuts olympiques, qu’il s’agisse du hockey sur glace à 3 x 3, du double féminin en luge ou du ski alpinisme. Les JOJ d’hiver de Lausanne 2020 seront les premiers où les sexes seront à parité. En tant que femme et ancienne athlète, c’est une cause qui m’est chère. Ci-dessus: Virginie Faivre transmet ses connaissances aux jeunes skieurs. À gauche: le ski alpinisme est l’une des nouvelles disciplines de ces JOJ.  En tant que femme, que signiﬁe être responsable de l’organisation de Lausanne 2020? Le fait qu’une femme préside le comité d’organisation de Lausanne 2020 envoie un message très fort. Cela offre un point de vue différent et complémentaire. L’ajout d’une touche féminine est un atout qui donne un élan positif aux JOJ. Il faut souligner l’importance des efforts du CIO. Le Mouvement olympique fait manifestement de gros efforts pour inclure les femmes. Il est là pour montrer l’exemple, en envoyant des signaux forts en soutien au sport féminin et aux Fédérations Internationales qui désormais suivent la tendance. Nous avons la chance que le Mouvement olympique montre la voie. ■  REVUE OLYMPIQUE 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title\" style=\"top:149px;left:67px;\" src=\"/113/static/_content/40-title.png\">\n        <img class=\"halfScale 40-title\" style=\"top:227px;left:67px;\" src=\"/113/static/_content/40-sub.png\">\n        <img class=\"halfScale 40-title\" style=\"top:490px;left:415px;\" src=\"/113/static/_content/40-quote.png\">\n\n        <div class=\"addContentLink\" style=\"top:225px;left:65px;height:14px;width:284px;\">\n            <a href=\"https://stillmed.olympic.org/media/Document%20Library/OlympicOrg/News/2019/07/List-of-ARMs-Lausanne-FR.pdf#_ga=2.166731006.1114590094.1568712471-504494508.1560240236\" target=\"_blank\"></a> \n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg40Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "LAUSANNE 2020  UNE ÉQUIPE D’ATHLÈTES MODÈLES D’ÉLITE APPORTERA SON AIDE POUR DÉLIVRER LE PROGRAMME D’ÉDUCATION OLYMPIQUE AUX JEUNES ATHLÈTES DE LAUSANNE 2020.  Grâce aux JOJ, les jeunes athlètes ont la chance non seulement d’accroître leur expérience en participant à un événement sportif pour les jeunes de haut niveau, mais aussi de découvrir une vaste gamme d’activités qui leur offrent de précieuses leçons de vie tant sur le terrain qu’en dehors. Ce programme éducatif a été l’un des éléments clés de chaque édition des JOJ. Pour Lausanne 2020, le comité d’organisation a collaboré avec le CIO, les Fédérations Internationales (FI), l’Université de Lausanne (UNIL), l’École polytechnique fédérale de Lausanne (EPFL) et l’Hôpital universitaire de Lausanne (CHUV) afin de préparer une offre attractive et passionnante pour les 1 880 athlètes qui seront en lice en janvier prochain. Ce programme, qui se déroulera dans les deux villages olympiques de la jeunesse, proposera sept activités reposant sur trois piliers: protéger l’athlète, travailler sur la  performance et aider l’athlète au-delà du sport. «Concernant la partie protection, il s’agit de faire comprendre [à l’athlète] qu’il est un modèle et qu’il doit prendre soin de sa santé», explique Olivier Mutter, enseignant à l’UNIL, responsable du programme éducatif de Lausanne 2020. «Pour ce qui est de la performance, il s’agit, en collaboration avec l’INSEP (l’Institut national du sport, de l’expertise et de la performance en France), de lui faire passer des tests pour qu’il prenne conscience de ses forces et de ses faiblesses, de la façon dont il peut mieux s’entraîner pour que sa carrière soit plus longue et couronnée de succès. Et quand on évoque ce qu’il y a au-delà du sport, cela concerne sa gestion des relations avec les médias, de sa carrière, etc.» Comme pour les JOJ précédents, de nombreuses activités prévoient des jeux amusants, des prix prestigieux et d’autres éléments interactifs pour inciter les jeunes  athlètes à participer. Par ailleurs, chaque FI a eu l’occasion d’élaborer d’autres activités pour les athlètes de son sport dans le cadre de «Journées de réflexion», à savoir des journées spécifiques consacrées à un sport en particulier avec les spécialistes de la discipline pour informer les jeunes athlètes sur des sujets qui les concernent eux et leurs sports. Les principales figures de ces journées des FI seront les membres de l’équipe des athlètes modèles, choisis par chaque FI pour agir comme soutiens et mentors des  jeunes athlètes durant les JOJ. Parmi les stars annoncées comme athlètes modèles pour Lausanne 2020 figurent la championne olympique allemande de luge Tatjana Hüfner, la championne olympique américaine de bosses Hannah Kearney et le célèbre curleur canadien John Morris. Double champion olympique, ce dernier est déjà prêt à devenir le mentor de jeunes athlètes lors de ces JOJ. «Plus jeune, chaque fois que j’ai pu rencontrer des athlètes plus âgés et plus expérimentés, cela m’a beaucoup inspiré, dit-il. J’ai eu beaucoup de chance d’avoir remporté des médailles d’or dans ma carrière en curling et j’ai l’impression que je pourrai avoir une influence et un impact sur la prochaine génération. C’est une très belle occasion de rendre à ce sport ce qu’il m’a donné et de transmettre mon expérience aux athlètes plus jeunes.» ■  «J’AI L’IMPRESSION QUE JE POURRAI AVOIR UNE INFLUENCE SUR LA PROCHAINE GÉNÉRATION. C’EST UNE TRÈS BELLE OCCASION DE RENDRE À CE SPORT CE QU’IL M’A DONNÉ.» JOHN MORRIS, ATHLÈTE MODÈLE Ci-contre: les athlètes modèles conseilleront les athlètes des JOJ.  40 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"42-title\" style=\"top:249px;left:102px;\" src=\"/113/static/_content/42-title.png\">  \n        <img class=\"halfScale\" id=\"42-sub\" style=\"top:387px;left:70px;\" src=\"/113/static/_content/42-sub.png\">  \n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.fromTo(idOf(\"42-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"42-sub\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg42Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO  UNE FORMATION D’EXCEPTION LES JEUX OLYMPIQUES DE LA JEUNESSE NE SONT PAS UNIQUEMENT UN TREMPLIN POUR LA CARRIÈRE DE JEUNES ATHLÈTES. ILS SONT AUSSI UNE ÉTAPE CRUCIALE POUR LES JEUNES REPORTERS DU CIO QUI COUVRENT CES JEUX. PAR STEPHEN WILSON.  C  ’est deux mois après le passage dévastateur de l’ouragan Maria sur la petite île caribéenne de la Dominique en 2017 qu’Ethan “Sharome” Burton a reçu l’appel surprise. Il était alors occupé à rendre compte des dégâts causés par la tempête à la radio nationale dominicaine, un changement par rapport à sa tâche habituelle de reporter sportif. L’appel en question provenait du CNO dominicain, pour l’informer que sa candidature était proposée pour le programme des jeunes reporters du CIO aux Jeux Olympiques de la Jeunesse (JOJ) de Buenos Aires 2018. On lui a signalé que la date limite de dépôt des candidatures approchait et qu’il devait déposer son dossier sans tarder. Toujours occupé par le chaos et les destructions laissés par l’ouragan, le jeune reporter de 22 ans s’est donc hâté de renvoyer les formulaires.  42 REVUE OLYMPIQUE  «J’étais persuadé que cela ne donnerait rien,» confie-t-il. «Je ne travaillais pas dans la presse depuis très longtemps et venant d’une petite île, je pensais que je n’avais aucune chance.» Un mois plus tard, la nouvelle inattendue est tombée: Burton était accepté dans le programme. Il allait être l’un des 35 jeunes journalistes du monde entier à se rendre à Buenos Aires pour recevoir une formation sur le terrain, pris en charge par des mentors professionnels de la presse olympique. «J’étais super excité, mais je savais aussi que je manquais d’expérience et que j’aurais beaucoup à faire pour être sûr de réaliser du bon boulot pour moi-même et aussi pour mon pays», explique Burton. Non seulement il a bien travaillé mais il est revenu d’Argentine avec le Trophée Steve Parry, du nom du regretté responsable des sports de Reuters, décerné au jeune reporter le plus"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n      \n      <svg onclick=\"Publish.openGallery(['42-gal-1.jpg', '42-gal-2.jpg', '42-gal-3.jpg', '42-gal-4.jpg', '42-gal-5.jpg', '42-gal-6.jpg', '42-gal-7.jpg', '42-gal-8.jpg', '42-gal-9.jpg', '42-gal-10.jpg'])\" class=\"abs pointer pulse animatedpulse \"style=\"left:464px;width:70px; top:504px; height:70px;\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\">\n          <g>\n            <path fill=\"#FFF\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"/>\n            <path fill=\"#FFF\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n              M123.685,63.134h-20.209v-5.966h20.209V63.134z\"/>\n          </g>\n          <g>\n            <path fill=\"#FFF\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n              L154.856,78.867z\"/>\n          </g>\n        </svg>\n      \n      ",
    "script": "\n        function onPageEnter() {\n        }\n    \n        function onPageLeave() {\n        }\n      ",
    "searchText": "Ci-dessus: la victoire de Ghofrane Belkhir immortalisée par une photographie (à gauche); réaliser des interviews est une expérience cruciale (à droite); les jeunes reporters du CIO suivent un cours préparatoire (cicontre); Sharome Burton reçoit le Trophée Steve Parry (page de droite).  44 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"45-quote\" style=\"top:556px;left:50px;\" src=\"/113/static/_content/45-quote.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n            pg42Anim = new TimelineMax();\n            pg42Anim.fromTo(idOf(\"45-quote\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n            pg45Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO  «C’est l’expérience la plus fantastique de ma vie! Cela a fait de moi un meilleur professionnel et un adulte plus mûr.» Sharome Burton  talentueux du programme à Buenos Aires 2018. À présent, Burton va se joindre aux 15 autres jeunes reporters qui poursuivront leur formation en couvrant les JOJ d’hiver de Lausanne 2020. «C’est un nouveau défi, ajoute Sharome Burton. Je ne suis jamais allé en Europe et je n’ai jamais vu la neige! J’espère que ce sera un autre tremplin pour ma carrière professionnelle.» Son récit n’est que l’une des nombreuses histoires à succès du programme des jeunes reporters du CIO lancé avec les premiers JOJ à Singapour en 2010 et qui, depuis, a permis à de jeunes journalistes doués de parfaire leurs compétences à chaque édition de ces Jeux. À l’heure actuelle, nombre des anciens de ce programme poursuivent une carrière dans les médias sportifs. «C’est l’expérience la plus fantastique de ma vie!», s’exclame Burton à propos de son séjour en Argentine. «Cela m’a donné  un meilleur sens du monde du travail, non seulement dans les médias mais aussi ce que cela signifie d’être un professionnel, de respecter des délais, la capacité de travailler avec des collègues. Cela a fait de moi un meilleur professionnel et un adulte plus mûr.» À chaque édition des JOJ d’été, une nouvelle promotion de jeunes reporters du monde entier, sélectionnés sur dossiers présentés par les CNO, se forme sous la tutelle de mentors expérimentés issus de la presse olympique. Les meilleurs participants sont retenus pour aller couvrir les JOJ d’hiver suivants. À Buenos Aires, les jeunes reporters ont bénéficié de plusieurs jours de formation théorique dispensée dans le domaine de l’écrit, de la photographie, de la vidéo/ diffusion et des réseaux sociaux. Les reporters ont ensuite été envoyés sur le terrain par petits groupes et, par rotations sur plusieurs jours avec divers mentors,  REVUE OLYMPIQUE 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n          \n        }\n    \n        function onPageLeave() {\n\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:318px;left:72px;height:365px;width:133px;\">\n            <a href=\"https://stillmed.olympic.org/media/Document%20Library/OlympicOrg/News/2019/05/2019-05-22-Young-Reporters-French.pdf#_ga=2.74085840.337935617.1575996578-164563661.1569488991\" target=\"_blank\"></a> </div>\n      ",
    "script": "\n        function onPageEnter() {\n            setTimeout(function(){\n                addContentLinks();\n              },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO  Jeunes reporters Lucas Marinelli (Argentine) Dylan Burns (Australie) Anmar Goodridge-Boyce (Barbados) Xiao Yazhuo (Chine) Filip Ozbolt (Croatie) Sharome Burton (Dominique) Chloe Knott (Grande-Bretagne) Annesha Ghosh (Inde) Paloma Gutiérrez Méndez (Mexique) Jeroen Adriaanse (Pays-Bas) Niall Anderson (Nouvelle-Zélande) Fatima Martinez Cabrera (Paraguay) Mbosse Seck (Sénégal) Berta Ballesteros Casado (Espagne) Emma Holmsen (Suède) Laura Godenzi (Suisse) Mentors Écrit: Stephen Wilson Photos: Nick Didlick Vidéo/diffusion: Tracey Holmes, Farhad Shadravan et Ivan Boyanov  À gauche: Shohei Uda faisait partie du premier programme des jeunes photographes du CIO. Ci-dessus: Laura Godenzi (à droite) a profité des connaissances des autres à Lillehammer 2016.  ils ont reçu une brève formation dans les divers formats qu’il y a lieu de maîtriser dans le paysage multimédia actuel. Buenos Aires 2018 a vu également la naissance d’un programme pour les photographes, et six jeunes photographes ont été adjoints aux Services olympiques d’information (OIS). Depuis sa création, plus de 100 jeunes journalistes, hommes et femmes, de 60 pays sont passés par le programme des jeunes reporters. L’équilibre hommefemme et l’universalité fait partie intégrante de ce programme, qui représente autant d’occasions uniques pour de jeunes journalistes de plusieurs petits pays tels que Vanuatu, les îles Solomon, Palau, le Togo, mais aussi le Myanmar. «C’est une occasion rare et unique», explique Tracey Holmes, journaliste sportive australienne, mentore à chaque édition des JOJ. «Non seulement les jeunes reporters deviennent des journalistes mais ils s’épanouissent en tant que personnes. Ils rentrent chez eux avec une compréhension approfondie du monde dans lequel ils vivent. Pour les mentors, il s’agit de savoir cibler le potentiel de ces jeunes journalistes qui arrivent aux JOJ avant qu’euxmêmes réalisent ce dont ils sont capables. Aider à leur épanouissement et les suivre individuellement des années durant par la suite est vraiment très gratifiant.»  Pour Lausanne 2020, le nouveau groupe comprend huit femmes et huit hommes de 16 pays, représentant les meilleurs des 35 jeunes participants au programme de Buenos Aires 2018 (les 35 ont reçu une accréditation pour Tokyo 2020). Alors que les JOJ d’été mettent davantage l’accent sur l’enseignement et la formation théorique, le programme des JOJ d’hiver se concentre davantage sur l’action sportive. Les jeunes reporters de Lausanne 2020 débuteront tous au centre de presse principal de la ville hôte avant de se scinder par petits groupes pour couvrir des épreuves sur les sites de compétition à Lausanne, dans le Jura, les Alpes et à Saint-Moritz. Les reporters et leurs mentors séjourneront au Vortex, le village olympique de la jeunesse situé sur le campus de l’Université de Lausanne, tandis qu’une petite équipe s’installera sur le site des épreuves de glisse et de patinage de vitesse de Saint-Moritz. Le CIO prend en charge le coût du transport aérien des jeunes reporters, leur hébergement dans une chambre à deux, les vêtements d’hiver et les repas. Une grande partie du travail des reporters sera publié sur le site officiel de Lausanne 2020 ainsi que sur les plateformes de réseaux sociaux. Le contenu sera en libre accès pour les athlètes des JOJ, les CNO, les Fédérations Internationales  REVUE OLYMPIQUE 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 48-quote\" style=\"top:559px;left:74px;\" src=\"/113/static/_content/48-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n            pg48Anim = new TimelineMax();\n            pg48Anim.staggerFromTo(cOf(\"48-quote\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n            pg48Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO  et les médias, avant d’être republié sous forme de reportages et d’articles. Le programme a formé plusieurs jeunes reporters, qui sont à leur tour devenus mentors, parmi lesquels l’Indienne Sonali Prasad. Jeune reporter de 18 ans, elle faisait partie du premier programme à Singapour et a été mentore spécialiste des réseaux sociaux à Buenos Aires huit ans plus tard. Sa sœur, Pallavi, jeune reporter à Nanjing 2014, a été mentore assistante en photographie à Buenos Aires, alors que le Bulgare Ivan Boyanov, colauréat du trophée Steve Parry en 2014, a travaillé en tant que mentor spécialiste de la retransmission à Buenos Aires, fonction qu’il retrouvera à Lausanne. Boyanov, qui avait déjà travaillé pour une station de télévision bulgare quand il a rejoint le programme des jeunes reporters, a reconnu que son expérience des JOJ avait facilité son apprentissage professionnel. Après Lillehammer 2016, une grande station de télévision de Bulgarie  «Notre tâche en tant que mentors est d’aider les jeunes reporters à découvrir leur propre facteur X et de les orienter dans la bonne direction.» Ivan Boyanov  48 REVUE OLYMPIQUE  À gauche: le président Bach pose avec les jeunes reporters à Nanjing 2014. Ci-dessus: depuis son expérience aux JOJ, Ivan Boyanov travaille à plein temps."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:148px;left:92px;height:20px;width:136px;\">\n            <a href=\"https://atos.net/fr/jeux-olympiques \" target=\"_blank\"></a> </div>\n      ",
    "script": "\n        function onPageEnter() {\n            setTimeout(function(){\n                addContentLinks();\n              },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n        ",

    "searchText": "As the Worldwide IT Partner of the Olympic Games since 2001, Atos delivers critical Games applications, IT security, cloud services and many more solutions to help create the Olympic Games of the future. Want to see what the Olympic story could mean to you? Join us at atos.net/olympicgames  Maximum performance to build your journey to success Trusted partner for your Digital Journey"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 50-quote\" style=\"top:428px;left:579px;\" src=\"/113/static/_content/50-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n            pg50Anim = new TimelineMax();\n            pg50Anim.staggerFromTo(cOf(\"50-quote\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n\n        function onPageLeave() {\n            pg50Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "(BTV) lui a proposé un emploi. Il réalise toujours des documentaires pour elle et présente le journal et des reportages en direct. À présent Boyanov veut aider les autres jeunes journalistes à gravir les échelons, eux aussi. «Notre tâche en tant que mentors est d’aider les jeunes reporters à découvrir leur propre facteur X et de les orienter dans la bonne direction, dit-il. Le paysage des médias a beaucoup changé dans les dix dernières années, mais l’objectif demeure le même, raconter une histoire intéressante, une histoire qui sera comprise.» Se tenir au courant des tendances les plus récentes et garder une longueur d’avance sont la base du succès du programme. Nick Didlick, mentor en photographie à chaque édition des JOJ depuis Singapour 2010, précise que le principal défi a été de s’adapter  50 REVUE OLYMPIQUE  aux changements rapides de la technologie et des réseaux sociaux. «Le principal enseignement que j’ai retiré de ce programme, c’est de voir les gens se tourner vers le monde de l’image, estime Didlick. Quasiment chaque jeune reporter vient me voir et me dit qu’il est nul en photographie. Je les aide à maîtriser les aspects techniques et à s’intéresser à la photo. Je trouve ça très gratifiant lorsqu’ils surmontent les défis technologiques et réalisent des tirages créatifs.» Le programme des jeunes reporters représente un réel mélange de jeunes hommes et femmes de diverses nationalités, origines et cultures, qui parlent des langues différentes. Les reporters apprennent à se connaître et restent ensuite en contact grâce aux réseaux sociaux. «Les liens d’amitié tissés avec des collègues du monde entier peuvent durer  «Les liens d’amitié avec des collègues du monde entier peuvent durer une vie entière.» Tracey Holmes  Ci-dessus: Nyein Su Wai Kyaw Soe immortalise du futsal en pleine action. À droite: les jeunes reporters du CIO à Buenos Aires."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO  une vie entière, explique Holmes. Dans une carrière où les contacts sportifs internationaux sont essentiels, le programme des jeunes reporters offre une formation de base incomparable.» Il suffit d’interroger Burton, symbole de fierté nationale à la Dominique depuis son succès dans le programme de 2018. «C’est super de représenter une lueur d’espoir pour beaucoup de Dominicains et surtout parmi les jeunes. Montrer que si on travaille dur et qu’on s’engage, on peut réussir, dit-il. Je veux être source d’inspiration pour les prochaines générations de jeunes journalistes et les professionnels de la Dominique.» Sa carrière a pris un nouveau tournant. En effet, Burton s’est inscrit  à la Midwestern State University à Wichita Falls (Texas), où il étudie l’ingénierie mécanique et la science informatique. Parallèlement, il tient la rubrique sportive du journal des étudiants à ses moments perdus. Il s’est également découvert une nouvelle passion, le cyclisme, et il défend les couleurs de l’équipe de l’université. «Sans mon expérience à Buenos Aires, je serais incapable de concilier la moitié de ce que je fais à présent: mes examens, mon entraînement, mes recherches et plein d’autres choses, reconnaît Burton. L’expérience de jeune reporter m’a bien préparé à gérer toute cette pression.» La pression va croître maintenant que Burton poursuit son nouveau rêve: se qualifier en cyclisme sur route pour  les Jeux du Commonwealth de 2022. Et au-delà, peut-être, aux Jeux Olympiques de Paris 2024. De jeune reporter à athlète olympique, pourquoi pas? «Ce serait incroyable, dit Burton. Paris 2024 c’est l’objectif à long terme, mais c’est un objectif!» Et ce ne serait certes pas un mauvais sujet d’article pour un futur jeune reporter du CIO. ■ Stephen Wilson est ancien responsable des sports et correspondant olympique de l’agence Associated Press pour l’Europe. Il est également ancien président de l’Association des journalistes olympiques. Il a été mentor pour ce programme en 2018 et le sera en 2020."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"52-title\" style=\"top:149px;left:68px;\" src=\"/113/static/_content/52-title.png\">  \n        <img class=\"halfScale\" id=\"52-sub\" style=\"top:175px;left:68px;\" src=\"/113/static/_content/52-sub.png\">  ",
    "script": "\n        function onPageEnter() {\n            pg52Anim = new TimelineMax();\n          pg52Anim.fromTo(idOf(\"52-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"52-sub\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg52Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO  ÉTUDE DE CAS «Ce programme a changé ma vie»  S  onali Prasad était une jeune étudiante de 18 ans à Singapour lorsque, à la demande pressante du directeur de son école, elle s’est portée candidate et, à sa grande surprise, a été acceptée pour intégrer le programme des jeunes reporters du CIO pour les JOJ de 2010. Elle ne se doutait pas de l’impact qu’aurait cette expérience sur sa vie et sa carrière. «Je suis arrivée dans le groupe avec le moins d’expérience ou de formation en journalisme, mais ces semaines avec les mentors m’ont bousculée, reconnaîtelle. Le programme des jeunes reporters a changé ma vie et les mentors qui m’ont formée, et dont l’enseignement se poursuit, ont été essentiels pour moi.» Depuis Singapour 2010, Sonali a eu un remarquable parcours olympique: jeune reporter à Innsbruck 2012, stagiaire à l’agence Press Association durant les Jeux de Londres 2012, reporter pour les Services olympiques d’information (OIS) à Sotchi 2014 et à Nanjing 2014, et innovatrice numérique au sein de l’équipe photo aux Jeux Paralympiques de Rio en 2016 et de PyeongChang 2018. En dehors du monde olympique, Sonali a été «Google News Lab Fellow» et «Pulitzer Travelling Fellow». Actuellement elle est boursière du programme «Knight Science Journalism» au Massachusetts Institute of Technology (MIT). Et en plus de tout ça, elle est elle-même devenue une mentore du programme des jeunes reporters, puisqu’elle a formé des journalistes aux réseaux sociaux à Buenos Aires 2018. «Devenir enseignante du programme qui m’a lancée est l’une des grandes étapes de ma carrière, estime Sonali. J’aime partager de nouvelles technoCi-contre: Sonali Prasad (centre) au MIT avec d’autres jeunes reporters.  52 REVUE OLYMPIQUE  logies avec les jeunes reporters, leur faire découvrir comment fonctionnent les données et le codage de base. Mais surtout, je souhaite qu’ils apprennent à devenir des reporters aimables et bienveillants, pas seulement des machines à produire du contenu! C’est ce qui demande le plus de temps.» Les compétences que Sonali a acquises en prenant part à ce programme se sont révélées précieuses tant dans sa carrière de journaliste que de mentor. «J’en suis sortie grandie et je n’hésite pas à me lancer dans  des expériences grâce à ma capacité à raconter des histoires, car j’ai de solides bases, dit-elle. Mais ce que mes mentors m’ont enseigné de plus important, et que je transmets à mes étudiants du programme des jeunes reporters, c’est qu’on doit toujours être prêt à oublier ce qu’on a appris et à réapprendre. Remettre les compteurs à zéro, sans idées préconçues. C’est surprenant à quel point on peut toujours en apprendre davantage.»"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Ci-dessus: Prasad interroge Ban Ki-moon lors du Forum Olympisme en action.  REVUE OLYMPIQUE 53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"54-title\" style=\"top:148px;left:68px;\" src=\"/113/static/_content/54-title.png\">  \n      <img class=\"halfScale\" id=\"54-sub\" style=\"top:175px;left:68px;\" src=\"/113/static/_content/54-sub.png\">  ",
    "script": "\n      function onPageEnter() {\n          pg54Anim = new TimelineMax();\n        pg54Anim.fromTo(idOf(\"54-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n        .fromTo(idOf(\"54-sub\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n      }\n  \n      function onPageLeave() {\n        pg54Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "JEUNES REPORTERS DU CIO  ÉTUDE DE CAS «La première fois que j’ai goûté aux reportages multimédias»  J  i Ye a toujours eu une passion pour le journalisme et les Jeux Olympiques et il parvient à combiner les deux avec succès dans sa carrière professionnelle. Après avoir œuvré en tant que volontaire aux Jeux de Beijing 2008, il a obtenu un emploi de journaliste sportif au sein de l’agence de presse chinoise Xinhua en 2009. Il a ensuite couvert sa première grande manifestation en tant que jeune reporter du CIO aux premiers JOJ de Singapour 2010. «Après avoir séjourné au village olympique de la jeunesse avec les jeunes athlètes, je peux témoigner avoir goûté à la magie des Jeux Olympiques à partir d’une position très privilégiée», dit-il. Avec 34 autres jeunes reporters, Ji a étoffé ses compétences grâce à une formation dispensée par des mentors sur une série de disciplines journalistiques, allant du judo au plongeon en passant par le football, entre autres épreuves. Il a réalisé une éphéméride quotidienne sur les jeunes athlètes et interviewé plusieurs futurs olympiens, notamment le champion olympique britannique de plongeon Tom Daley. «C’était la première fois que je goûtais aux reportages multimédias, se souvient Ji. Depuis 2010, les réseaux sociaux ont révolutionné le journalisme. Grâce au programme des jeunes reporters, je peux relever le défi qu’ils représentent.» Après Singapour, Ji a été sélectionné pour participer à la deuxième édition du programme des jeunes reporters aux JOJ d’hiver d’Innsbruck 2012, où il a continué sa formation pratique au reportage durant les Jeux. Ces deux expériences, Singapour et Innsbruck, lui ont permis d’étoffer sa carrière. Ji a couvert Londres 2012 pour Xinhua, À droite: Ji Ye interviewe le président Bach à PyeongChang.  54 REVUE OLYMPIQUE  avant d’être envoyé au Brésil pour couvrir la Coupe du monde de la FIFA 2014 et les Jeux de Rio 2016. Il a ensuite suivi PyeongChang 2018 et a fait partie de l’équipe des Services olympiques d’information (OIS) aux JOJ de Buenos Aires. Il a aussi réalisé un documentaire sur l’héritage de Nanjing 2014 diffusé lors de la Session du CIO de 2017 à Lima (Pérou). Ji est à présent de retour à Beijing, où il traite tout ce qui est en  rapport avec les Jeux d’hiver de Beijing 2022, tout en prêtant son concours au projet OIS du comité d’organisation. «En tant que participant du programme des jeunes reporters des premiers JOJ d’été et d’hiver, les JOJ m’ont vraiment inspiré, dit-il. Ma carrière et ma vie sont très étroitement liées aux Jeux. Grâce au programme des jeunes reporters, je ne ménage pas mes efforts pour rendre compte de l’esprit olympique.»"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 56-title\" style=\"top:500px;left:66px;\" src=\"/113/static/_content/56-title.png\">\n        <img class=\"halfScale 56-title\" style=\"top:590px;left:67px;\" src=\"/113/static/_content/56-sub.png\">\n        <img class=\"halfScale 56-circle\" style=\"top:587px;left:281px;\" src=\"/113/static/_content/56-circle.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg56Anim = new TimelineMax();\n          pg56Anim.staggerFromTo(cOf(\"56-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n            .fromTo(cOf(\"56-circle\"), 1, {x:80, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1.7)\n        }\n    \n        function onPageLeave() {\n          pg56Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "À TRAVERS L’OBJECTIF JOJ  À TRAVERS L’OBJECTIF À L’APPROCHE DES JOJ D’HIVER DE LAUSANNE 2020, NOUS AVONS RETROUVER LES PHOTOS DE PARTICIPANTS DES JOJ QUI, DEPUIS, ONT HISSÉ LEUR CARRIÈRE À DE NOUVEAUX SOMMETS.  SABRINA SIMADER À l’époque: Sabrina a 17 ans et fait les gros titres de Lillehammer 2016, en tant que première représentante du Kenya à des JOJ d’hiver, soutenue par Philip Boit, premier Kenyan olympien d’hiver. Aujourd’hui (en médaillon): Sabrina, qui a 21 ans, est la première skieuse alpine professionnelle kenyane. Elle a pris part aux Championnats du monde et à la Coupe du monde de la FIS, ainsi qu’aux Jeux d’hiver de PyeongChang 2018.  56 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "À TRAVERS L’OBJECTIF  REVUE OLYMPIQUE 57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 58-circle\" style=\"top:247px;left:322px;\" src=\"/113/static/_content/58-circle.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim.fromTo(cOf(\"58-circle\"), 1, {x:80, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.7, 1)\n        }\n    \n        function onPageLeave() {\n          pg58Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "À TRAVERS L’OBJECTIF JOJ  01 JACQUELINE LÖLLING À l’époque: l’Allemande Jacqueline Lölling a été la première lauréate du skeleton femmes aux JOJ en gagnant l’or à Innsbruck 2012. Aujourd’hui (en médaillon): elle est passée avec succès dans les rangs seniors et a remporté l’argent aux Jeux d’hiver de PyeongChang 2018. Elle a aussi décroché le titre mondial en 2017 et a remporté à deux reprises la Coupe du monde.  02 RASMUS WRANÅ À l’époque: Rasmus Wranå aux traits juvéniles (au centre) est le skip de l’équipe mixte suédoise de curling aux JOJ d’Innsbruck 2012. Il conduit son pays jusqu’au match pour la 3e place, perdu face au Canada. Aujourd’hui (en médaillon): après sa carrière junior, qui lui a valu une 2e place aux Championnats du monde juniors de curling en 2012, Rasmus Wranå a décroché deux titres mondiaux, trois titres européens et l’argent aux Jeux de PyeongChang 2018.  03 LISA VITTOZZI À l’époque: l’Italienne Lisa Vittozzi, 16 ans, concourt en biathlon aux JOJ d’hiver d’Innsbruck 2012. Elle y termine 5e de la poursuite, 8e du sprint et cinquième du relais mixte. Aujourd’hui (en médaillon): Lisa Vittozzi a décroché le bronze avec l’équipe italienne de relais mixte aux Jeux de PyeongChang 2018 puis remporté la 2e place du 15 km individuel aux Championnats du monde de 2019 et le titre individuel de la Coupe du monde.  58 REVUE OLYMPIQUE  01  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 59-circle-1\" style=\"top:482px;left:0px;\" src=\"/113/static/_content/59-circle-1.png\">\n        <img class=\"halfScale 59-circle-2\" style=\"top:-47px;left:131px;\" src=\"/113/static/_content/59-circle-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg59Anim = new TimelineMax();\n          pg59Anim.fromTo(cOf(\"59-circle-1\"), 1, {x:80, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1.4)\n            .fromTo(cOf(\"59-circle-2\"), 1, {y:-80, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1.8)\n        }\n    \n        function onPageLeave() {\n          pg59Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "À TRAVERS L’OBJECTIF  03  REVUE OLYMPIQUE 59"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 60-circle-1\" style=\"top:223px;left:31px;\" src=\"/113/static/_content/60-circle-1.png\">\n        <img class=\"halfScale 60-circle-2\" style=\"top:607px;left:436px;\" src=\"/113/static/_content/60-circle-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg60Anim = new TimelineMax();\n          pg60Anim.fromTo(cOf(\"60-circle-1\"), 1, {x:80, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"60-circle-2\"), 1, {y:-80, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1.4)\n        }\n    \n        function onPageLeave() {\n          pg60Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "À TRAVERS L’OBJECTIF JOJ  01  02  60 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 61-circle-1\" style=\"top:267px;left:208px;\" src=\"/113/static/_content/61-circle.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg61Anim = new TimelineMax();\n          pg61Anim.fromTo(cOf(\"61-circle-1\"), 1, {x:-80, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1.8)\n        }\n    \n        function onPageLeave() {\n          pg61Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "À TRAVERS L’OBJECTIF  01 HWANG DAE-HEON À l’époque: Hwang, patineur de vitesse sur piste courte de la République de Corée, démontre un grand talent tactique et décroche l’or aux JOJ d’hiver de Lillehammer 2016. Aujourd’hui (en médaillon): il a battu le record du monde du 1 000 m peu après et remporté le classement général de la Coupe du monde 2017/18. À PyeongChang 2018, il a gagné l’argent dans le 500 m, distance sur laquelle il est également double champion du monde.  02 STEFANIE WETLI À l’époque: Stefanie Wetli, 16 ans, fait partie de l’équipe suisse de hockey sur glace qui décroche la médaille de bronze aux JOJ de Lillehammer 2016. Elle est créditée de l’assistance sur un but lors de la victoire décisive 5-2 contre la Slovaquie. Aujourd’hui (en médaillon): malgré son jeune âge, la défenseuse est devenue titulaire en équipe nationale suisse senior. Stefanie Wetli a disputé les Jeux Olympiques de PyeongChang 2018 et les Championnats du monde de l’IIHF. 03 03 CHLOE KIM À l’époque: à 15 ans seulement, la snowboardeuse américaine Chloe Kim attire les regards aux JOJ d’hiver de Lillehammer 2016 et remporte avec brio l’or du slopestyle et du halfpipe. Aujourd’hui (en médaillon): Chloe Kim est l’une des plus grandes stars des sports d’hiver. Championne olympique de halfpipe à PyeongChang 2018, elle a remporté les Championnats du monde 2019 et cinq victoires aux X Games.  REVUE OLYMPIQUE 61"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 63-title\" style=\"top:339px;left:152px;\" src=\"/113/static/_content/63-title.png\">\n        <img class=\"halfScale 63-title\" style=\"top:435px;left:150px;\" src=\"/113/static/_content/63-sub.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg63Anim = new TimelineMax();\n          pg63Anim.staggerFromTo(cOf(\"63-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg63Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOKYO 2020 EN POINT DE MIRE  TOKYO 2020 EN POINT DE MIRE:  VIKTOR HOVLAND QUE LA ROUTE A ÉTÉ LONGUE POUR LE GOLFEUR NORVÉGIEN VIKTOR HOVLAND DEPUIS QU’IL A MANQUÉ DE PEU LE PODIUM DES JEUX OLYMPIQUES DE LA JEUNESSE DE NANJING 2014. À 22 ANS, IL REVIENT AVEC MICHAEL STONEMAN SUR SA RAPIDE ASCENSION AU SEIN DU GOLF MONDIAL ET EXPLIQUE COMMENT IL COMPTE REMONTER SUR LA SCÈNE OLYMPIQUE À TOKYO.  E  n tapant sa première balle lors du troisième et dernier tour du tournoi de golf masculin des Jeux Olympiques de la Jeunesse (JOJ) de Nanjing 2014, Viktor Hovland semblait sur le point d’entrer dans l’histoire sportive. Compte tenu du retour du golf au programme olympique, pour la première fois depuis 1904, le tournoi des JOJ a fait l’objet d’un intérêt accru au Golf Club international de Zhongshan. Après avoir ramené deux cartes de 68, Hovland, du haut de ses 16 ans, dominait le classement et il ne lui restait plus que 18 trous pour devenir le premier homme à décrocher une médaille d’or en golf depuis 110 ans et, de fait, le tout premier champion de golf des JOJ. Cependant, avoir débuté la journée à moins huit, avec un coup d’avance sur le Thaïlandais Danthai Boonma et deux sur l’Australien Brett Coletta, coleader avec le Suédois Marcus Kinhult à l’issue du premier parcours, les choses n’ont pas tourné comme prévu pour Hovland. «J’ai bien joué les deux premiers tours, en signant deux fois 68, mais dans le dernier tour, je n’ai pas bien putté, reconnaît-il. Je m’en souviens très bien. Je n’ai pas joué comme j’aurais dû quand il le fallait. Certes, j’ai plutôt bien joué, mais je n’ai pas été assez bon sur le green.»  La carte de 74 de Hovland, soit deux au-dessus du par, l’a fait rétrograder au troisième rang ex aequo avec Boonma. Le bogey du Norvégien sur le trou 18 a contraint les deux hommes à disputer un barrage en mort subite pour l’attribution du bronze, alors que l’Italien Renato Paratore décrochait l’or grâce à sa dernière carte de 66, devant Kinhult. Il a fallu se rendre à deux reprises sur le green du 18 pour départager les deux joueurs. Auteur d’un mauvais drive lors du deuxième trou de barrage, Hovland a manqué le green, tandis que Boonma a réussi son approche en plaçant sa balle à 3 m du drapeau. Hovland n’a pu terminer en deux coups, ce qui lui aurait permis de rester dans le par, si bien que le Thaïlandais Boonma a obtenu le bronze grâce à deux petits putts. Certes déçu d’avoir manqué un podium historique, Hovland a mis ce résultat sur le compte de son jeune âge, bien déterminé à ce que cela lui serve de leçon. «Sur le coup, j’ai trouvé cela un peu catastrophique! C’était en effet une occasion unique de prendre part à cette compétition, conﬁe-t-il. Mais je savais que ce ne serait pas mon dernier tournoi de golf et qu’il fallait que j’analyse les raisons de mon échec en identiﬁant mes faiblesses. En fait, c’était le putt principalement. À chaque fois qu’on participe  REVUE OLYMPIQUE 63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 64-quote\" style=\"top:545px;left:543px;\" src=\"/113/static/_content/64-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.fromTo(cOf(\"64-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg64Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOKYO 2020 EN POINT DE MIRE  à une compétition et qu’on doit réaliser certains coups pour demeurer dans la course, pour remporter un tournoi ou n’importe quoi d’autre, quel que soit le résultat obtenu, on en retire énormément d’enseignements.» Mais si Paratore et Kinhult, ses adversaires aux JOJ, sont rapidement passés professionnels et ont capitalisé sur leur expérience olympique fructueuse sur le circuit européen - Paratore a remporté le Masters scandinave en 2017 et Kinhult a triomphé au Masters britannique de 2019 - Hovland a décidé, pour sa part, d’aller peauﬁner son jeu sur le circuit universitaire américain, en acceptant une bourse de l’université d’état de l’Oklahoma. «Je savais qu’ils n’iraient pas à l’université et que de toute évidence le succès les attendait. Ils ont réussi à obtenir leur carte sur le circuit et Renato a gagné peu de temps après, souligne-t-il. Lorsque j’étais encore à l’université, je m’étais fait la réﬂexion qu’il n’y a pas si longtemps je jouais encore avec eux chez les juniors et qu’à présent, ils remportaient des épreuves professionnelles sur le circuit européen. À l’époque, je n’étais pas prêt et je savais que je devais passer par la ﬁlière universitaire pour parfaire mes compétences. Et avec le recul, je ne changerais rien aujourd’hui.» On comprend facilement pourquoi Viktor Hovland estime avoir fait le bon choix. En effet, il a non seulement remporté le titre national universitaire 2018 avec l’équipe des Cowboys de l’Oklahoma State, mais il a aussi gagné trois tournois universitaires en individuel. En outre, il est devenu le premier Norvégien à s’imposer dans le prestigieux US Open amateur 2018, le championnat amateur américain, ce qui lui a valu des invitations pour trois des quatre grands tournois professionnels masculins en 2019: le Masters, l’US Open et l’Open britannique. Hovland a terminé meilleur amateur au Masters, ce qui lui a permis de devenir numéro un mondial chez les amateurs, et à l’US Open à Pebble Beach, où il a terminé douzième avec un total de 280, battant le record du score le plus bas réalisé par un amateur sur les 72 trous, détenu jusque-là par un certain Jack Nicklaus. Ces exploits lui ont valu de recevoir le Trophée Ben Hogan 2019 de meilleur golfeur universitaire des États-Unis, prouvant ainsi son aptitude à concourir désormais au plus haut niveau. Cela l’a décidé à passer pro après l’Open américain, renonçant du même coup à son invitation à l’Open britannique. Une nouvelle fois, cela s’est avéré être une décision judicieuse, puisque Hovland  64 REVUE OLYMPIQUE  est passé sans encombre dans les rangs des joueurs rémunérés. Il a commencé sa carrière professionnelle en terminant dans les 20 premiers de cinq de ses six premiers départs sur le circuit de la PGA, dont une quatrième place ﬁnale au Wyndham Championship, et a battu le vieux record du nombre de tours consécutifs sur le circuit sous les 70. La percée instantanée d’Hovland au sommet du circuit professionnel est inversement proportionnelle aux débuts relativement lents de sa carrière de golfeur en Norvège. Pour ses trois ans, son père lui offre un jeu de clubs de golf, mais pendant longtemps il préfère jouer au football et pratiquer le taekwondo. Il faut attendre ses 11 ans pour qu’il se tourne plus activement vers le golf et même à l’adolescence, alors qu’il perfectionne son talent, il n’a toujours pas conscience d’être particulièrement doué pour ce sport. «Je m’en sortais mais je n’étais pas vraiment bon par rapport aux joueurs de ma génération, se rappelle-t-il. J’ai pu intégrer un pôle junior à 13 ou 14 ans, mais je n’ai jamais été le meilleur  «J’AI TRES,BIEN JOUE, MAIS JE N’AI PAS ETE LA HAUTEUR ET JE NE SAVAIS PAS SI J’ETAIS ASSEZ BON.» VIKTOR HOVLAND de mon groupe. J’étais juste content d’en faire partie. Et je n’ai pas vraiment gagné quoi que ce soit chez les juniors. J’avais de bons résultats çà et là, mais je n’ai jamais été le meilleur.» Deux ans après sa médaille de bronze manquée aux JOJ de Nanjing 2014, Viktor Hovland échoue à nouveau aux portes d’une autre grande compétition, et cet échec s’accompagne de nouveaux doutes quant à son aptitude à concourir au plus haut niveau. «Deux semaines avant d’intégrer l’université, j’ai ﬁni deuxième du Championnat d’Europe amateur, dit-il. J’ai perdu après sept tours de barrage! J’ai très bien joué, mais je n’ai tout simplement pas été à la hauteur. Je ne savais pas si je ne"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",

    "script": "\n        function onPageEnter() {\n        }\n    \n        function onPageLeave() {\n        }\n      ",
    "searchText": "jouais pas sufﬁsamment bien pour pouvoir obtenir des résultats réguliers, pour être le meilleur lors de chaque tournoi et être constant, ou si c’était un coup de chance. «Ma première année universitaire a été plutôt bonne, mais je ne me suis jamais dit que j’étais un crack. J’ai continué à m’améliorer au ﬁl des années et c’est comme ça que je suis devenu accro au golf car, au fond, j’aimais ça et je me suis rendu compte que je progressais.» Ces progrès ont constitué un tournant majeur pour Viktor Hovland lorsqu’il a remporté le tournoi sur invitation universitaire de Valspar en Floride, sa première victoire. «Après avoir gagné ça, ma première compétition universitaire, j’ai réalisé que tout était possible. Savoir que j’avais une chance de gagner m’a donné énormément conﬁance en moi lors des compétitions suivantes. Tout est parti de là. L’US Open amateur est le deuxième tournoi que j’ai gagné et cela a ouvert les vannes!» Le Trophée Havemeyer plaqué or de l’US Open amateur, que des golfeurs de légende comme Bobby Jones, Jack Nicklaus, Arnold  Page de gauche: Hovland au début du Masters. Ci-dessus: posant avec le Trophée Havemeyer. Ci-contre: Hovland jouant un coup aux JOJ.  REVUE OLYMPIQUE 65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 66-quote\" style=\"top:257px;left:68px;\" src=\"/113/static/_content/66-quote.png\">\n        ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.staggerFromTo(cOf(\"66-quote\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg66Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOKYO 2020 EN POINT DE MIRE  «J’ESPERE ALLER AUX JEUX OLYMPIQUES L’AN PROCHAIN. CA ME TROTTE INCONTESTABLEMENT DANS LA TETE.» VIKTOR HOVLAND  Ci-contre: Hovland espère devenir l’un des meilleurs golfeurs du monde alors qu’il vise l’or olympique. Ci-dessus, à droite: la foule observe Hovland jouer un coup d’approche au club de golf de Wentworth.  66 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 67-title\" style=\"top:167px;left:559px;\" src=\"/113/static/_content/67-title.png\">\n      <img class=\"halfScale 67-title\" style=\"top:250px;left:560px;\" src=\"/113/static/_content/67-sub.png\">\n    ",
    "script": "\n      function onPageEnter() {\n        pg67Anim = new TimelineMax();\n        pg67Anim.staggerFromTo(cOf(\"67-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n      }\n  \n      function onPageLeave() {\n        pg67Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "TOKYO 2020 EN POINT DE MIRE  PROPOS DE TOKYO VIKTOR HOVLAND SURÉ La croissance du golf olympique Quand je vois toute la ﬁerté de Justin Rose, Henrik Stenson et Matt Kuchar quand ils ont gagné leurs médailles à Rio, tout ce que cela a signiﬁé pour eux et à quel point cela les a aidés, je crois que cela a incité de nombreux joueurs à se remotiver. Cela leur a peut-être ouvert les yeux sur le fait que gagner une médaille aux Jeux ne s’improvise pas.  Palmer, Tiger Woods et Phil Mickelson ont tous décroché, est de l’avis général la récompense la plus prisée du golf amateur. «C’est incontestablement ce qui a tout déclenché chez moi», reconnaît Viktor Hovland. Ce succès m’a offert de nombreuses possibilités. Je ne serais pas là où j’en suis aujourd’hui sans ma victoire à l’US Open amateur. Je n’y pensais pas vraiment à l’époque, mais quand je vois tous les noms qui ont gagné ce tournoi, je suis plutôt ﬁer d’appartenir à cette confrérie particulière.» Hovland a de nouveau gravé son nom sur les tablettes de l’histoire en signant sa performance époustouﬂante dans l’US Open 2019, éclipsant le score record établi chez les amateurs par Nicklaus en 1960. «C’est dingue d’avoir battu un record qui tenait depuis si longtemps! Et pour être honnête, le plus fantastique c’est que c’était un record de Jack Nicklaus! Mais ce n’est pas vraiment très important. Évidemment, c’est un exploit gratiﬁant, mais j’essaye juste de devenir meilleur en golf et de jouer aussi bien que possible.» Si le jeune Norvégien continue de s’améliorer, il devrait pouvoir atteindre quelques-uns de ses objectifs en 2020: sa qualiﬁcation dans l’équipe européenne de la Ryder Cup et sa présence sous les couleurs de son pays aux Jeux de Tokyo 2020.  «Faire partie de l’équipe de la Ryder Cup serait sans doute pour moi l’une des choses les plus géniales à réaliser en golf, mais c’est dans un an et ce n’est pas gagné d’avance. Je dois m’acharner et continuer à m’améliorer pour peut-être intégrer cette équipe, conﬁe Hovland. «J’espère aussi aller aux Jeux Olympiques l’an prochain. Ça me trotte dans la tête, mais comme on joue énormément de tournois chaque année, je m’efforce de ne pas trop m’emballer. Il est facile de tirer des plans sur la comète et de penser à tout ça. Évidemment, c’est important car il faut bien se ﬁxer des objectifs et des ambitions qui valent la peine de se battre. Mais ça l’est aussi de se laisser prendre à ce jeu-là trop souvent… C’est ensuite qu’on réalise qu’il faut s’y mettre et travailler! Je m’efforce donc de rester dans le présent autant que faire se peut et simplement de m’améliorer. J’espère que tout ça ﬁnira peut-être par payer si je fais les choses correctement.» Si on se penche sur son parcours, de la déception de Nanjing et ses fabuleux records chez les amateurs jusqu’aux débuts impressionnants de sa carrière professionnelle, il est évident que jusqu’à présent, Viktor Hovland a fait ce qu’il fallait. S’il poursuit dans cette voie alors peut-être aura-t-il une nouvelle occasion d’écrire un autre chapitre de l’histoire olympique à Tokyo. ■  Son désir de se qualiﬁer pour les Jeux C’était plutôt génial de participer aux Jeux Olympiques de la Jeunesse de 2014 et j’espère que l’an prochain je pourrai aussi prendre part aux Jeux Olympiques à Tokyo. J’y pense sans arrêt, mais on dispute énormément de tournois toutes les semaines et je tâche de ne pas trop m’emballer.  REVUE OLYMPIQUE 67"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 68-title\" style=\"top:292px;left:160px;\" src=\"/113/static/_content/68-title.png\">\n      <img class=\"halfScale 68-title\" style=\"top:341px;left:107px;\" src=\"/113/static/_content/68-sub.png\">\n      <a href=\"https://www.olympicchannel.com/fr/films/detail/running-in-north-korea/film/running-in-north-korea-film/\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:60px; height:60px;left:370px;top:400px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#FFF\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#FFF\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n    ",
    "script": "\n      function onPageEnter() {\n        pg68Anim = new TimelineMax();\n        pg68Anim.staggerFromTo(cOf(\"68-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n      }\n  \n      function onPageLeave() {\n        pg68Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "COURIR EN CORÉE DU NORD DEUX OLYMPIENNES D’HIVER ONT ACCEPTÉ DE PARTIR À L’AVENTURE EN PARTICIPANT AU MARATHON DE PYONGYANG POUR UN NOUVEAU DOCUMENTAIRE D’OLYMPIC CHANNEL. LEUR SÉJOUR EN RÉPUBLIQUE POPULAIRE DÉMOCRATIQUE DE CORÉE A, UNE NOUVELLE FOIS, RÉVÉLÉ LE POUVOIR UNIFICATEUR DU SPORT. PAR CONOR KETLEY."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n    \n        function onPageLeave() {\n\n        }\n      ",
    "searchText": "Les olympiens d’hiver sont souvent plus à l’aise en compétition sur des pentes enneigées que sur de longues routes sinueuses. Pourtant, en avril 2019, Aimee Fuller et Mirjam Jaeger n’ont pas hésité à troquer leurs skis et leur planche de snowboard pour des baskets, après avoir décidé de courir le marathon dans cette partie retirée du monde. Le prix international du marathon du Mangyongdae, plus connu sous le nom de marathon de Pyongyang, est sans doute la course de fond la plus mystérieuse de la Terre et Aimee Fuller et Mirjam Jaeger  ont tenté leur chance en participant à l’épreuve dans la capitale de la RPDC. À 37 ans, Mirjam Jaeger n’a participé qu’une fois aux Jeux Olympiques d’hiver, ceux de Sotchi en 2014 avant d’achever sa carrière sportive en 2015. Aimee Fuller a, quant à elle, concouru à Sotchi ainsi qu’à PyeongChang 2018, et elle espère bien poursuivre sa carrière sportive dans les années qui viennent. «J’ai reçu un message d’Olympic Channel, me disant: “J’ai vu que vous alliez courir le marathon de Londres, ça vous dirait d’en courir un autre?”,  Ci-contre: départ du marathon de Pyongyang 2019."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DANS LES COULISSES D’OLYMPIC CHANNEL  raconte Aimee Fuller à la Revue Olympique. «J’ai commencé par dire non, mais lorsqu’on m’a dit que c’était en Corée du Nord, ma curiosité l’a emporté!» Ce n’est un secret pour personne que la RPDC est un pays pratiquement fermé au reste du monde. Mais en 2000, elle a décidé de rouvrir ses portes aux sportifs étrangers par le biais d’un marathon. Obtenir un dossard pour cette manifestation annuelle est une occasion exceptionnelle, étant donné que pas plus d’un millier d’athlètes étrangers y prennent part chaque année. Et c’est la seule épreuve sportive du pays dont la participation est ouverte au-delà de la population locale. Le scénario de Running in North Korea (Courir en Corée du Nord) dépasse de loin ce que suggère son titre. Certes, l’aventure de ces deux femmes prend tout son sens avec la course elle-même, mais  70 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale\" id=\"71-quote\" style=\"top:578px;left:550px;\" src=\"/113/static/_content/71-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n            pg71Anim = new TimelineMax();\n            pg71Anim.fromTo(idOf(\"71-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n            pg71Anim.stop();\n            removeContentLinks();\n        }\n      ",
    "searchText": "DANS LES COULISSES D’OLYMPIC CHANNEL  elle avait déjà débuté quelques semaines auparavant. Se préparer pour un marathon est assez exigeant, d’autant plus que cette préparation allait de pair avec une mise en condition mentale en vue du séjour d’une semaine dans un pays dont elles savaient que rien n’y ressemblerait à l’idée toute faite qu’elles en avaient. «Vous pouvez faire toutes les recherches que vous voulez sur le pays, vous ne trouverez pas grand-chose», conﬁe Mirjam Jaeger à la Revue Olympique. «Je me posais beaucoup de questions sur la Corée du Nord à mon départ et j’en avais encore plus à mon retour.» La tension tant physique qu’émotionnelle des deux coureuses éclate aux yeux du spectateur. Aimee Fuller ne peut réprimer un sourire lorsqu’elle se présente à la porte d’embarquement de l’aéroport avant de décoller de Beijing. Elle fait part  Page de gauche: Aimee Fuller et Mirjam Jaeger sympathisent avec les athlètes du pays (en haut); un stade plein à craquer accueille les coureurs. Ci-dessus: le marathon mène les athlètes à travers les rues de la capitale.  de son anxiété en apprenant que chaque membre de l’équipe s’est vu assigner une chambre à un étage différent, dans un hôtel de Pyongyang apparemment inoccupé. De son côté, après avoir abandonné son téléphone et son ordinateur portables au départ de Chine, Mirjam Jaeger réalise qu’elle n’aura aucun contact avec sa famille, son compagnon et son jeune ﬁls. Malgré les diverses limitations concernant leur séjour, Aimee Fuller et Mirjam Jaeger s’embarquent pour de nombreuses sorties en ville et partout où Running in North Korea emmène le spectateur, un message revient sans cesse : le sport unit quel que soit l’environnement. Lors de leur séjour, les deux olympiennes rencontrent plusieurs athlètes de la RPDC. Elles écoutent leurs récits. Ainsi, durant la visite d’un lieu célèbre de Pyongyang, elles rencontrent l’haltérophile Om  «C’ÉTAIT MON PREMIER MARATHON ET J’AI DÉCOUVERT QUE LE SPORT PERMETTAIT D’HUMANISER L’INCONNU.» AIMEE FULLER, ATHLÈTE OLYMPIQUE D’HIVER Yun-chol, champion olympique dans la catégorie des 56 kg à Londres en 2012 et quintuple champion du monde, et l’athlète Jong Song-ok, championne du monde du marathon en 1999. Tous deux dédient leur succès à l’amour et à l’attention que leur témoignent l’État et le Leader suprême. Le pongiste Kim Song-i, médaillé de bronze à Rio 2016, estime que cette unité patriotique a créé «un lien encore plus  REVUE OLYMPIQUE 71"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:590px;left:64px;height:15px;width:97px;\">\n          <a href=\"https://www.olympicchannel.com/fr/ \" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n            setTimeout(function(){\n                addContentLinks();\n              },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n        ",
    "searchText": "profond» entre les membres de la délégation de la RPDC par rapport aux autres pays, ce qui leur permet de se surpasser sur la scène mondiale. Mais comme le révèle ce documentaire d’Olympic Channel, l’unité dans le sport peut aussi dépasser cet attachement au pays. Lors d’un jogging avec trois athlètes de la RPDC dans un stade voisin, Aimee Fuller et Mirjam Jaeger sont brièvement laissées à elles-mêmes. S’ensuit une scène aussi puissante que réconfortante entre les cinq athlètes. Elles éclatent de rire en s’efforçant de prononcer le nom des autres tout en effectuant leurs tours de piste. L’absence d’un interprète lors de cet entraînement permet une communication sans apprêt et transmet la trame profondément humaine du ﬁlm. «Le sport est une langue commune, explique Aimee Fuller. C’est l’une des choses qui nous relie les uns aux autres.» Les dernières images de Running in North Korea font écho à sa réﬂexion puisqu’on découvre un parc rempli de citoyens pratiquant différents sports. Que ce soit pour un simple jogging dans un parc ou un marathon complet, le sport permet aux peuples du monde entier de prendre contact et de communiquer. Running in North Korea démontre que même dans les conditions les plus extrêmes, le pouvoir uniﬁcateur du sport prévaut. ■ Regardez Running in North Korea sur olympicchannel.com et ses applications mobiles ou sur des téléviseurs connectés.  72 REVUE OLYMPIQUE  Ci-dessus: Ri Kang-bom célèbre sa victoire dans la course masculine. Ci-dessous: les athlètes répondent aux questions lors de la première à Londres.  CE QU’ELLES EN DISENT «C’est l’une des meilleures choses que j’ai faites, c’est une expérience qui m’a ouvert les yeux. Le sport est un outil puissant tant pour la santé physique et mentale, mais aussi un moyen de communication.»  «Je n’avais jamais vu autant de personnes sur les trottoirs! Je suis en fait très heureuse d’avoir décidé de me joindre à cette équipe. Ce n’est pas une destination où on décide de se rendre habituellement!»  AIMEE FULLER GRANDE-BRETAGNE  MIRJAM JAEGER SUISSE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympicchannel.com/fr\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:846px;left:238px;width:335px;height:61px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {}\n    \n        function onPageLeave() {}\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 75-title\" style=\"top:414px;left:350px;\" src=\"/113/static/_content/75-title.png\">\n      <img class=\"halfScale 75-title\" style=\"top:497px;left:350px;\" src=\"/113/static/_content/75-sub.png\">\n    ",
    "script": "\n      function onPageEnter() {\n        pg75Anim = new TimelineMax();\n        pg75Anim.staggerFromTo(cOf(\"75-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n      }\n  \n      function onPageLeave() {\n        pg75Anim.stop();\n        removeContentLinks();\n      }\n        ",
    "searchText": "MES JEUX  MES JEUX  TORA BERGER TORA BERGER EST LA PREMIÈRE NORVÉGIENNE À AVOIR GAGNÉ DE L’OR OLYMPIQUE EN BIATHLON, GRÂCE À SA VICTOIRE DANS LE 15 KM INDIVIDUEL À VANCOUVER 2010. TROIS AUTRES MÉDAILLES ONT SUIVI À SOTCHI 2014. ELLE REVIENT ICI SUR SON ÉBLOUISSANTE CARRIÈRE.  MES PREMIERS SOUVENIRS OLYMPIQUES  Ci-contre: Tora Berger a ajouté trois médailles olympiques à son palmarès lors des Jeux de Sotchi 2014.  Je me souviens encore d’avoir suivi les Jeux Olympiques d’hiver de 1992, c’était à Albertville. [Le skieur de fond norvégien] Bjørn Dæhlie était si impressionnant lors de ces Jeux qu’il en a été la grande star et l’un de mes héros. Deux ans plus tard, j’ai assisté aux Jeux de Lillehammer. J’avais 12 ans et c’était génial. Je n’en revenais pas de voir à quel point c’était grandiose et le monde qu’il y avait partout. Je me souviens que j’ai suivi le ski acrobatique: c’était la première fois que j’assistais à des épreuves de ce sport et nous avons décroché une médaille de bronze. En fait, la Norvège a gagné énormément de médailles et tout le monde était content. Je pense que le fait d’avoir assisté à ces Jeux a été le déclic, le moment qui m’a donné envie d’y aller moi-même un jour.  MES PREMIERS JEUX Lors de mes premiers Jeux, à Turin 2006, je savais que je n’avais pas de chance de gagner une médaille. Ce n’était pas l’objectif, mais c’était très agréable d’avoir la possibilité de participer. Je me suis rendu compte que c’était encore plus agréable de remporter la victoire. En voyant les vainqueurs avec leurs médailles, je me suis dit que moi aussi ça me plairait de gagner. Cela m’a inspirée, tant le fait d’avoir vécu l’expérience de Jeux si importants que d’avoir pu constater le sentiment qu’éprouvaient les vainqueurs au moment de recevoir leur médaille.  RIVALITÉ FRATERNELLE Mon frère [le vice-champion olympique Lars Berger] m’a inspirée, bien sûr! En fait on s’affrontait constamment! Mais je pense que cela a été très important pour moi. Je n’aurais peut-être pas été aussi  REVUE OLYMPIQUE 75"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": " \n        <a href=\"https://www.youtube.com/watch?v=UR5FSsC_pLw\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:40px; height:40px;left:295px;top:471px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n        <h1 id=\"76-no\" class=\"abs 76-no hn-bd\" style=\"left: 212px; top: 736px; font-size: 2.1em; font-family: HelveticaNeueLTPro-BdEx; font-weight: 700; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number=\"{&quot;to&quot;: 3 }\"></h1>\n        <h1 id=\"76-no\" class=\"abs 76-no hn-bd\" style=\"left: 308px; top: 735px; font-size: 2.1em; font-family: HelveticaNeueLTPro-BdEx; font-weight: 700; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number=\"{&quot;to&quot;: 4 }\"></h1>\n        <h1 id=\"76-no\" class=\"abs 76-no hn-bd\" style=\"left: 687px; top: 735px; font-size: 2.3em; font-family: HelveticaNeueLTPro-BdEx; font-weight: 700; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number=\"{&quot;to&quot;: 8 }\"></h1>\n      ",
    "script": "\n        function onPageEnter() {\n        pg76Anim = new TimelineMax();\n        pg76Anim.fromTo(cOf(\"76-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[0]);}}, 1)\n                .fromTo(cOf(\"76-no\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[1]);}}, \"-=0.3\")\n                .fromTo(cOf(\"76-no\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[2]);addContentLinks();}}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          pg76Anim.stop();\n          resetNumbers('76-no');\n        }\n      ",
    "searchText": "MES JEUX  donné envie d’aller mieux et d’embrasser une carrière sportive. Du coup, j’ai davantage planifié les choses et j’ai commencé à agir correctement. J’étais bien plus concentrée et cela m’a vraiment aidée.  RÊVES DORÉS  bonne s’il n’avait pas été là. J’avais besoin de mon frère pour me mesurer. with.  NE JAMAIS RENONCER Plus jeune, j’ai eu une période de méforme. Je voulais trop bien faire, je m’entraînais trop et j’avais tout faux. J’ai envisagé de tout laisser tomber parce que rien ne se passait bien. J’en ai parlé à ma mère qui m’a répondu que ma vie pouvait prendre beaucoup d’autres orientations. Ça m’a fait réfléchir. Ça m’a tout de suite  Ci-dessus: Berger a décroché l’or dans le 15 km à Vancouver 2010. Ci-dessus, à droite: à Lillehammer 2016 en tant qu’athlète modèle.  À l’école, on nous avait demandé d’écrire quelques lignes sur nos rêves. Le mien, c’était de gagner une médaille d’or aux Jeux Olympiques d’hiver de 2010. Je pense que je n’ai pas cru une seule seconde que j’aurais la chance d’y arriver – et je suis certaine que la prof non plus! – mais c’était mon rêve! J’ai eu du mal à l’écrire, car je ne l’avais jamais dit à personne, c’était mon petit secret. Mais noir su blanc, il est devenu plus réel. Plus qu’un rêve, c’est devenu un but!  UN RÊVE SE RÉALISE En fait j’ai retrouvé mon cahier d’écolière en 2008 et en le relisant, ça m’a fait sourire. C’était une période assez importante pour moi. Deux ans plus tard, j’ai gagné ma médaille d’or olympique. Devenir  championne m’a permis de me réaliser davantage. En tant qu’athlète, ce vieux rêve se concrétisait et j’ai vécu un moment particulier lorsque je suis montée sur le podium en sachant que j’avais tout simplement atteint mon but. Je n’oublierai jamais cette journée ni cette médaille d’or.  AIDER LES AUTRES À RÉALISER LEURS RÊVES J’avais un rêve et j’ai travaillé dur pour qu’il se réalise. Mais au fil des saisons, c’est devenu de plus en plus difficile de trouver la motivation. Lorsque je me suis retirée de la compétition [après la Coupe du monde 2013/14], j’ai tiré un trait sur le biathlon. J’ai quand même continué à chausser les skis tous les jours. C’est agréable d’aller skier pour le plaisir et d’être chez soi et de se détendre en famille. À présent, je travaille avec de jeunes athlètes. Ça me plaît de faire autre chose. J’ai tant reçu du sport que je voudrais que les enfants et les jeunes aient les mêmes chances que moi afin qu’ils puissent réaliser leurs propres rêves. ■  EN BREF  Née le 18 mars 1981 à Ringerike (Norvège)  76 REVUE OLYMPIQUE  3  A participé à trois éditions des Jeux Olympiques d’hiver, 2006, 2010, 2014  4  médailles olympiques en biathlon  1 or  1 or  1 argent  1 bronze  15 km individuel (Vancouver 2010)  relais mixte (Sotchi 2014)  10 km poursuite (Sotchi 2014)  relais 4 x 6 km (Sotchi 2014)  8  titres de championne du monde"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 78-title\" style=\"top:130px;left:108px;\" src=\"/113/static/_content/78-title.png\">\n        <img class=\"halfScale 78-sub\" style=\"top:186px;left:109px;\" src=\"/113/static/_content/78-sub.png\">\n        \n        <div class=\"addContentLink\" style=\"top:738px;left:543px;height:13px;width:100px;\">\n          <a href=\"https://www.olympic.org/library\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:763px;left:543px;height:13px;width:115px;\">\n          <a href=\"mailto: studies.centre@olympic.org\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:193px;left:539px;height:14px;width:127px;\">\n          <a href=\"https://www.olympic.org/library\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:194px;left:243px;height:14px;width:176px;\">\n          <a href=\"mailto: studies.centre@olympic.org\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"78-sub\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ÉTUDES OLYMPIQUES  ÉTUDES OLYMPIQUES LE CENTRE D’ÉTUDES OLYMPIQUES DU CIO EST VOTRE SOURCE DE CONNAISSANCE OLYMPIQUE. POUR NOUS CONTACTER: STUDIES.CENTRE@OLYMPIC.ORG OU RENDEZ-VOUS SUR OLYMPIC.ORG/STUDIES  OLYMPIC WORLD LIBRARY L’Olympic World Library est la source de référence pour les principaux thèmes relatifs aux Jeux Olympiques et au Mouvement olympique. À la fois catalogue de bibliothèque et portail d’informations, elle offre un accès direct à plus de 35 000 titres de monographies – dont 9 000 sous format électronique – sur des sujets qui touchent aux aspects historiques, économiques, sociaux et culturels de l’Olympisme. La collection s’enrichit continuellement de 1 000 à 1 500 parutions chaque année. Les utilisateurs peuvent y découvrir la plus originale et la plus complète des collections de publications officielles du CIO, l’ensemble des rapports publiés par les comités d’organisation des Jeux Olympiques, les Comités Nationaux Olympiques et les Fédérations Internationales, et une vaste collection de livres, revues et articles universitaires. Afin de faciliter la recherche professionnelle et universitaire, le Centre d’Études Olympiques (CEO) publie régulièrement un contenu thématique qui permet aux lecteurs de retrouver facilement et directement les informations les plus pertinentes. L’accent est mis plus particulièrement sur les ressources et sujets qui soulèvent l’intérêt récurrent des professionnels et universitaires. En tant que tel, l’Olympic World Library publie et met à jour régulièrement une collection spéciale de documents et de pages. On trouve ainsi des pages sur des thèmes particuliers comme l’intégralité des collections  78 REVUE OLYMPIQUE  historiques des dossiers et documents de chaque candidature, des rapports officiels des Jeux Olympiques, de la Revue Olympique, des Chartes olympiques et la description des contenus et les règles d’accès des archives historiques du CIO. La Collection de référence du CEO met à disposition des informations complètes et chronologiques sur les principaux thèmes liés au Mouvement olympique, aux Jeux Olympiques et au CIO, portant sur l’ensemble de l’histoire des Jeux Olympiques modernes. Les documents donnent des précisions importantes sur les faits, chiffres, anecdotes et autres images sur des sujets qui vont des Jeux Olympiques à l’histoire des sports au programme olympique, en passant par les villages olympiques, les stades, les relais de la flamme, mascottes, médailles, pictogrammes sportifs et bien plus encore. Soigneusement illustrés, ces documents permettent un accès de première main à une information à jour et  représentent une ressource précieuse pour la production de contenu et de références. Une collection de pages thématiques, «ZOOM SUR», offre aux chercheurs un accès facile à des sources officielles et universitaires sélectionnées, sur des sujets qui vont des Jeux Olympiques de l’Antiquité à l’héritage des Jeux Olympiques modernes, mais aussi sur la durabilité, l’éducation olympique, les Olympiades culturelles, l’éthique et la bonne gouvernance, les femmes dans le sport et autres domaines d’intérêt. L’Olympic World Library s’enrichit sans cesse de nouvelles parutions. Pour rester à jour, ses usagers, peuvent s’inscrire et recevoir des alertes hebdomadaires ou mensuelles. ■ L’Olympic World Library est accessible à www.olympic.org/library Contactez le Centre d’Études Olympiques à studies.centre@olympic.org"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:810px;left:164px;height:15px;width:75px;\">\n          <a href=\"https://dow.com\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:770px;left:131px;height:18px;width:77px;\">\n          <a href=\"https://twitter.com/downewsroom?lang=en\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:770px;left:227px;height:18px;width:61px;\">\n          <a href=\"https://twitter.com/DowSports\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:787px;left:98px;height:18px;width:206px;\">\n          <a href=\"https://www.linkedin.com/showcase/dow-olympic-sports-solutions\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n            setTimeout(function(){\n                addContentLinks();\n              },1000)\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Collaboration It’s where innovation begins  Our world is transforming, and our customers are facing constant change. They need a partner who will help them innovate to seize new opportunities and capture growth. That’s why we are committed to being the world’s most customer-centric materials science company. Through close collaboration, we work hard to understand our customers’ objectives and challenges, asking questions that lead to productive dialogue, stronger relationships and new answers. We are Dow, the world’s most customer-centric materials science company. @DowNewsroom and @DowSports Dow and Dow Olympic & Sports Solutions  dow.com ® and ™ are Trademarks of The Dow Chemical Company © 2019"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "\n      <div class=\"abs noOverflow\" style=\"top:157px;left:67px;width:290px;height:27px\">\n        <img class=\"halfScale 81-title\" id=\"81-title\" src=\"/113/static/_content/81-title.png\">\n        </div>\n        <div class=\"abs noOverflow\"  style=\"top:185px;left:66px;width:294px;height:42px\">\n        <img class=\"halfScale 81-sub\" style=\"top: 12px\" src=\"/113/static/_content/81-sub.png\">\n        </div>\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg81Anim = new TimelineMax();\n          pg81Anim.fromTo(cOf(\"81-title\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"81-sub\"), 0.6, {y:-30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg81Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "DÉCÈS  HALVARD HANEVOLD TRIPLE CHAMPION OLYMPIQUE ET QUINTUPLE CHAMPION DU MONDE NORVÉGIEN DE TRIATHLON ENTRE 1995 ET 2010  Triple champion olympique norvégien de biathlon, Halvard Hanevold est décédé à 49 ans. Après ses premiers Jeux à Lillehammer 1994, il avait gagné sa première médaille d’or dans le 20 km individuel aux Jeux d’hiver de Nagano quatre ans plus tard et remporté l’argent dans le relais. Il avait décroché sa deuxième médaille d’or dans la même épreuve à Salt Lake City en 2002, avant d’ajouter à sa  collection le bronze du 20 km et l’argent du sprint à Turin 2006. Il avait enfin rapporté de Vancouver 2010 sa troisième et dernière médaille d’or, pour sa dernière saison. Hanevold était aussi monté 16 fois sur le podium des 16 Championnats du monde avant de se retirer du biathlon, sans réellement s’éloigner du sport puisqu’il était devenu commentateur sportif à la NRK.  BLANCA FERNÁNDEZ OCHOA La médaillée olympique de bronze espagnole de ski alpin Blanca Fernández Ochoa est décédée à 56 ans. Née dans une famille de skieurs à succès, elle avait participé à quatre éditions des Jeux d’hiver et avait remporté le bronze du slalom féminin à Albertville 1992, devenant ainsi la première femme à offrir une médaille à l’Espagne aux Jeux Olympiques d’hiver. TEVFIK KIŞ Le champion olympique turc de lutte Tevfik Kış est décédé à 85 ans. Il avait décroché l’or en poids mi-lourds à Rome 1960, avant de remporter deux titres mondiaux consécutifs dans la même catégorie en 1962 et 1963. Après avoir concouru à Mexico en 1968, Kış était devenu entraîneur de l’équipe nationale de son pays.  ENRIQUETA BASILIO La sprinteuse mexicaine Enriqueta Basilio, première femme à allumer la vasque olympique aux Jeux de Mexico 1968, est décédée à 71 ans. Durant la cérémonie d’ouverture, elle avait porté la flamme dans le stade olympique et, après un tour de piste, avait gravi l’escalier et enflammé la vasque, un épisode emblématique et historique pour les femmes aux Jeux Olympiques.  NEALE LAVIS  BRUNO GRANDI  HARRISON DILLARD  Bruno Grandi, ancien président de la Fédération Internationale de Gymnastique (FIG) est décédé à 85 ans. Ardent gymnaste junior, cet Italien a marqué l’histoire de l’administration du sport, d’abord en tant que président de la Fédération italienne de gymnastique, puis à la tête de la FIG. Il avait été membre du CIO de 2000 à 2004.  Harrison Dillard, le seul homme à avoir réalisé le doublé olympique 100 m plat / 110 m haies, est décédé à 96 ans. Inspiré par Jesse Owens, originaire comme lui de Cleveland, Dillard avait remporté l’or du 100 m à Londres 1948 avant d’entrer dans l’histoire à Helsinki 1952 en gagnant le 110 m haies. Il était aussi membre du relais 4 x 100 m américain, victorieux lors des deux éditions.  Le champion olympique de sports équestres Neale Lavis est décédé à l’âge de 89 ans. Lavis avait écrit une page d’histoire avec ses trois partenaires de l’équipe australienne en remportant la première médaille olympique jamais remportée par l’Australie en équitation dans le concours complet par équipes de Rome 1960. Il avait également gagné la médaille d’argent du concours complet individuel lors de ces mêmes Jeux, avant de concourir à Tokyo 1964. Lavis avec été intronisé dans le Temple de la renommée du sport australien en 1989.  REVUE OLYMPIQUE 81"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 82-title\" style=\"top:110px;left:66px;\" src=\"/113/static/_content/82-title.png\">\n        <img class=\"halfScale 82-sub\" style=\"top:155px;left:67px;\" src=\"/113/static/_content/82-sub.png\">\n        <img class=\"halfScale 82-1-title\" style=\"top:198px;left:66px;\" src=\"/113/static/_content/82-1-title.png\">\n        <img class=\"halfScale 82-1-sub\" style=\"top:221px;left:67px;\" src=\"/113/static/_content/82-1-sub.png\">\n        <img class=\"halfScale 82-1-list\" style=\"top:310px;left:67px;\" src=\"/113/static/_content/82-1-list.png\">\n        \n        <img class=\"halfScale 82-2-title\" style=\"top:526px;left:67px;\" src=\"/113/static/_content/82-2-title.png\">\n        <img class=\"halfScale 82-2-sub-1\" style=\"top:648px;left:78px;\" src=\"/113/static/_content/82-2-sub-1.png\">\n        <img class=\"halfScale 82-2-sub-2\" style=\"top:795px;left:66px;\" src=\"/113/static/_content/82-2-sub-2.png\">\n\n        <img class=\"halfScale 82-3-title\" style=\"top:760px;left:285px;\" src=\"/113/static/_content/82-3-title.png\">\n        <img class=\"halfScale 82-3-sub-1\" style=\"top:796px;left:285px;\" src=\"/113/static/_content/82-3-sub-1.png\">\n        <img class=\"halfScale 82-3-line\" style=\"top:757px;left:511px;\" src=\"/113/static/_content/82-3-line.png\">\n        <img class=\"halfScale 82-3-sub-2\" style=\"top:727px;left:515px;\" src=\"/113/static/_content/82-3-sub-2.png\">\n\n        <img class=\"halfScale 82-4-title\" style=\"top:525px;left:636px;\" src=\"/113/static/_content/82-4-title.png\">\n        <img class=\"halfScale 82-4-sub-1\" style=\"top:573px;left:636px;\" src=\"/113/static/_content/82-4-sub-1.png\">\n        <img class=\"halfScale 82-4-sub-2\" style=\"top:717px;left:636px;\" src=\"/113/static/_content/82-4-sub-2.png\">\n        <img class=\"halfScale 82-4-sub-3\" style=\"top:814px;left:636px;\" src=\"/113/static/_content/82-4-sub-3.png\">\n        <h1 id=\"82-no\" class=\"abs 82-no hn-bd\" style=\"left: 634px; top: 762px; font-size: 2.7em; font-family: HelveticaNeueLTPro-Hv; font-weight: 700; color: #FFF; padding: 0px; margin: 0px; opacity: 1;\" data-number='{\"to\": 1200}'></h1>\n\n        <img class=\"halfScale 82-5-title\" style=\"top:198px;left:461px;\" src=\"/113/static/_content/82-5-title.png\">\n        <img class=\"halfScale 82-5-sub-1\" style=\"top:219px;left:461px;\" src=\"/113/static/_content/82-5-sub-1.png\">\n        <img class=\"halfScale 82-5-sub-2\" style=\"top:405px;left:665px;\" src=\"/113/static/_content/82-5-sub-2.png\">\n\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(cOf(\"82-title\"), 0.6, {y:-40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"82-sub\"), 0.6, {y:-40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n\n          .fromTo(cOf(\"82-1-title\"), 0.6, {x:-40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(cOf(\"82-1-sub\"), 0.6, {x:-40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-1-list\"), 0.6, {x:-40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n\n          .fromTo(cOf(\"82-2-title\"), 0.6, {x:-40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(cOf(\"82-2-sub-1\"), 0.6, {x:-40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-2-sub-2\"), 0.6, {x:-40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          \n          .fromTo(cOf(\"82-3-title\"), 0.6, {y:40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(cOf(\"82-3-sub-1\"), 0.6, {y:40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-3-line\"), 0.6, {y:40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-3-sub-2\"), 0.6, {y:40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n\n          .fromTo(cOf(\"82-4-sub-3\"), 0.6, {x:40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(cOf(\"82-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0]);}}, \"-=0.4\")\n          .fromTo(cOf(\"82-4-sub-2\"), 0.6, {x:40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-4-sub-1\"), 0.6, {x:40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-4-title\"), 0.6, {x:40, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n\n          .fromTo(cOf(\"82-5-sub-2\"), 0.6, {y:-40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(cOf(\"82-5-sub-1\"), 0.6, {y:-40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-5-title\"), 0.6, {y:-40, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          \n          \n          \n        }\n    \n        function onPageLeave() {\n          pg82Anim.stop();\n        }\n      ",
    "searchText": "EN BREF Faits et chiffres concernant les innovations des JOJ d’hiver de Lausanne 2020  INNOVATIONS SPORTIVES  INFRASTRUCTURE FR AS ASTR INFR TRUC UCTU UC IIN NFRAS TR  UN NOUVEAU FORMAT POUR LE HOCKEY SUR GLACE  À SAINT-MORITZ, LES SITES DE GLACE NATURELLE SERONT RÉUTILISÉS POUR le bobsleigh le skeleton le patinage de vitesse la luge  3x3 LES AUTRES NOUVELLES ÉPREUVES SKI ALPINISME LUGE EN DOUBLE FEMMES COMBINÉ NORDIQUE FEMMES  LA VAUDOISE ARÉNA sera réaménagé après les JOJ pour la natation, l’escrime, le tennis de table et les sports de glace  TRANSPORTS  VORTEX HAUTEUR: 27 m SURFACE TOTALE DU DOMAINE: 36 700 m2  DE NOUVELLES LIGNES DE BUS seront ouvertes pour desservir les sites olympiques  Aucune source d’énergie externe ne sera nécessaire  VASQUE OLYMPIQUE Les athlètes des JOJ se rendront sur les sites en TRANSPORTS EN COMMUN GRATUITS  Des pellets de bois alimenteront la vasque: une grande première olympique en matière de combustible durable  DEUX VAGUES d’athlètes afin d’augmenter les capacités d’accueil et élever le niveau des compétitions  1 200 ÉTUDIANTS seront logés au Vortex après les JOJ  *INFORMATION PROVENANT DES RAPPORTS DU CIO ET D’OLYMPIC.ORG  VILLAGE OLYMPIQUE DE LA JEUNESSE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Imagine if the world could see what a mom sees. #LoveOverBias"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \" \";\n          var decChar = \",\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length - 1) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-137252729-40',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T53c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eBnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.cd0e6080075eb408b7eb.js